// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sign Font */

.sidebar_open {
  /* padding: 22px; */
  /* float: inherit;*/
  /* border: 1px solid #DFDFDF;
     background: #fff; */
  width: 100%;
  margin: 0px;
  border-radius: 0;

  min-height: 100%;
  height: auto;
  float: left;
}
.he-65,
.he-60 {
  max-height: 67vh;
  overflow-y: auto;
}
/* .sidebar_opn {
    padding: 22px;
    height: calc(100% - 30px);
    float: inherit;
    width: inherit;
    border-radius: 10px;
    overflow: scroll;
} */

.avatar {
  /*height: 40px;
    width: 40px;
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
    min-width: 40px;
    line-height: 30px;*/
  width: 45px;
  height: 45px;
  border: 1px solid #dfdfdf;
  border-radius: 100%;
  text-align: center;
  line-height: 45px;
  color: #302b3a;
  font-weight: 800;
  display: inline-block;
}
.textSty {
  width: 100%;
  justify-content: center;
  color: #000;
}
.avatar p {
  color: #fff;
  font-weight: 700;
  margin: -3px;
  width: 50px;
}
.alignTops .dropbtn {
  min-height: 54px;
}
.dropbtn.btnArw:after {
  top: 25px;
}

/*.alignTops .candidate .avatar{
    height: 54px;
    width: 54px;
    min-width: 54px;
    line-height: 43px;
}
.alignTops .candidate .avatar p {
    font-size: 18px;
    font-weight: 700 !important;
}*/

.candidate img {
  width: 40px;
  height: 40px;
  border-radius: 50px;
}
.close-image {
  /* margin: -38px 0px 0px 80px; */
  width: 15px;
  position: absolute;
  top: 7px;
  right: 10px;
}
/*pv*/
html,
body,
#root {
  overflow-x: hidden;
}

.textarea .notes-box :hover,
textarea .notes-box :focus {
  border: 1px solid #dcdcdc !important;
}
.download-img {
  margin: 3px 20px 0px 0px;
}
.under-line {
  width: 100%;
  border: 1px solid #dcdcdc;
  margin: -11px 0px 0px 0px;
}
.dot {
  height: 25px;
  width: 25px;
  background-color: none;
  border-radius: 50%;
  display: inline-block;
  color: #ffb900;
  font-size: 15px;
  border: 1px solid #ffb900;
}
.number-dot {
  padding: 0px 0px 0px 8px;
}

.call-text {
  color: #666;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.no-msg {
  text-align: center;
  margin: 60px 0px 0px 0px;
  font-size: 15px;
  color: black !important;
  font-weight: 500;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  line-height: normal;
  /* text-transform: capitalize; */
}
.check-add_icon {
  width: 40%;
  padding: 0px 6px 5px 0px;
}
.add-pop {
  display: flex;
  position: relative;

  height: 40px;
  float: right;
}
.add-pop-selects {
  display: flex;
  position: relative;

  height: 40px;
  width: 100%;
  /*       max-width: 173px; */
  top: 4px;
  float: right;
}

/*pv*/

iframe.frame-view {
  width: 100%;
  height: calc(100vh - 188px);
  overflow: scroll;
  max-height: 70vh;
}
button.update-btn {
  color: #fff;
  border: 0;
  width: auto;
  justify-content: space-between;
  border-radius: 10.093px;
  background: #3a68d8;
  margin: -8px 0px 0px 25px;
  text-align: center;
  min-width: 80px;
  font-size: 15px;
}
.candidate {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hd-can {
  display: flex;
  align-items: center;
  /* min-height: 70px;*/
  min-height: 45px !important;
}
/* .hd-can h4 {
    margin-bottom: -7px;
    font-size: 14px;
} */
.hd-can-review {
  /* display: flex; */
  align-items: center;
  height: auto;
  padding: 15px 15px 0px 35px;
}
.form-floating.mb-5 {
  margin: 15px 0px 0px 0px;
}

.form-floating.mb-5 {
  margin: 15px 0px 0px 0px;
}

.hd-can-review h4 {
  color: var(--Avenu-Black, #302b3a) !important;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.hd-can-review.create-form-wrp.newPad h4 {
  margin: 0;
}

.hd-can-review.create-form-wrp h4.mainTits {
  font-family: "Manrope", sans-serif !important;
  font-weight: 600;
  font-size: 16px;
  margin: 0;
}

.contents-sub.padd-main .action-itms.full-drp:last-child {
  margin: 0 !important;
}

button.btn_resetFrom {
  /* min-height: 44px;
    min-width: 120px !important;*/
  border-radius: 10px;
  letter-spacing: 0 !important;

  color: #fff;
  border: 0;
  width: auto;
  min-width: 100px;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  margin-left: 10px;
}
.hd-can-review .create-form-wrp {
  flex-direction: column;
  align-items: flex-start;
}
.hd-can-review .create-form-wrp {
  flex-direction: column;
  align-items: flex-start;
}

.hd-can-review .create-form-wrp h4 {
  margin-bottom: 10px;
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  padding: 20px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  margin-top: -20px;
}
.candidate .ca-details {
  margin-left: 10px;
}

.ca-details {
  /*margin-left: 40px;*/
}

.ca-details h3 {
  margin-bottom: 0px;
  font-size: 17px;
}
.d-flex.userlist ul {
  margin: 0px;
}
span.count-ca {
  /*background: #3A68D8; 
    width: 27px !important;
    height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px 0px 0px 5px;
    border-radius: 55px;*/
  background: #3a68d8;
  line-height: 31px;
  min-width: 30px;
  height: 30px;
  border-radius: 60px;
  display: inline-block;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  padding: 0 7px;
  margin-left: 8px;
}
span.count-ca .count-number {
  margin: 0;
  padding: 0;
  line-height: 1;
}

.docBrad li.breadcrumb-item a {
  color: #666666;
  font-size: 13px;
  font-weight: 500;
}
.docBrad li.breadcrumb-item.active {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.topAlg {
  margin: 0 3px 0 0;
}

.topAlg hr {
  padding: 0;
  margin: 10px 0 0;
  opacity: 0.05;
}

ol.breadcrumb {
  align-items: center;
}
.progress-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #000;
  font-size: 12px;
  font-weight: 700;
}
table.table td.tabLast_ch {
  width: 100px;
  text-align: end;
}
.tabLast_ch .f-btns.doc {
  display: flex;
  justify-content: end;
  align-items: center;
}
.tabLast_ch .f-btns.doc button {
  padding: 0 5px;
  margin: 0 0 0 5px;
}
.tabLast_ch .f-btns.doc img {
  margin: 0 !important;
}

.detail-tabs .table tbody.table-text-body td {
  text-wrap: balance;
  min-width: 180px;
}
.detail-tabs
  .table
  tbody.table-text-body
  .firstTab.arrow-btwn.myteam-algment
  td {
  text-wrap: balance;
  max-width: 150px;
}

.detail-tabs
  .table
  tbody.table-text-body
  .firstTab.arrow-btwn.myteam-algmenttd
  .text-end
  td {
  text-wrap: balance;
  min-width: 170px;
}
td.text-end-onbo {
  min-width: 210px !important;
}
td.text-end.my-temss {
  min-width: 150px !important;
}
td.text-end.my-tems-staus {
  min-width: 195px !important;
}
.ca-details span {
  color: #666;
  font-family: "Manrope", sans-serif !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 25ch;
}
.ca-details span.styDiv {
  color: var(--color1);
}
.ca-details .styDiv {
  /* color: var(--gray-accessible-text, #666);*/
  color: #3a68d8;
  font-family: "Manrope", sans-serif !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0;
  margin: 0;
  width: 100%;
  /*text-decoration-line: underline !important;*/
  display: block;
}

.ca-details {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.ca-details h3 {
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
  max-width: 16ch !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.can-lists li.user-itm {
  position: relative;
  margin: 10px 0px 0;
  padding: 0px 15px 0px 14px;
}
.can-lists .user-itm a.candidate {
  padding: 0 0 13px;
  margin: 0 0px 0px;
  border-radius: 0;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.can-lists .user-itm a.candidate::before {
  border-left: 3px solid transparent;
  content: " ";
  position: absolute;
  left: 0px;
  top: 0;
  z-index: 1;
  height: 76%;
  display: inline-block;
  border-radius: 9px;
}
.can-lists .user-itm a.candidate.active::before {
  border-left: 3px solid var(--color1);
}
.can-lists .user-itm a.candidate.active .ca-details h3,
.can-lists .user-itm a.candidate.active .ca-details span {
  color: var(--color1) !important;
}
a.candidate {
  padding: 12px 0px;
  border-radius: 50px;
}
/* a.candidate.active {
    background: #F8F8F8;
} */
.ca-details span img {
  width: 16px;
  height: 16px;
}

img.download-pdf {
  width: 15px;
}
span.dwn {
  font-weight: 600;
}

ul.actn-btns li {
  margin-right: 1px;
}
ul.actn-btns.contDts li {
  display: flex;
  align-items: center;
}
ul.actn-btns.contDts li.emailTab {
  margin-left: 20px;
}

ul.actn-btns {
  display: flex;
  align-items: center;
}
ul.actn-btns li a img {
  width: 15px;
}
ul.actn-btns li:last-child {
  margin-right: 0px;
}
.llbw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 35px;
}
.detail-user .llbw {
  margin-bottom: 10px;
}

.progress-bar.detail {
  margin-left: 40px;
}
.main-de {
  margin-bottom: 20px;
}
.d-flex.inv-det button {
  margin: 5px;
  border: 1px solid #dfdfdf;
  color: var(--color1);
  background: #fff;
  border-radius: 5px;
  padding: 5px 20px;
  width: 85%;
  height: 35px;
}
.d-flex.inv-det button.active {
  background: var(--color1);
  color: #fff;
  width: 85%;
  height: 35px;
}
.d-flex.inv-det {
  flex-wrap: wrap;
  margin-top: 12px;
}
button.dwn {
  border: 0;
  background: none;
}
.react-tabs__tab--selected {
  background: none !important;
  border-color: var(--color1);
  color: black;
  border-radius: 0px;
  /* border: 3px solid transparent; */
  border-bottom: 3px solid #316af7 !important;
  color: #3a68d8 !important;

  font-family: "Manrope", sans-serif;
  font-style: normal;
  font-weight: 600 !important;
  line-height: normal;
}
.react-tabs__tab-list {
  border: 0 !important;
}
.react-tabs__tab:focus:after {
  background: none !important;
}
.tables.docTable table td:first-child {
  padding-left: 0 !important;
}

.tables.docTable table td:last-child {
  padding-right: 0 !important;
}

.tables.docTable table td {
  border-bottom: 1px solid #e8e8e8;
}

.react-tabs__tab {
  /*color: var(--colorGrey);*/
  color: #302b3a;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
  padding: 5px 0px 10px !important;
  border-radius: 0 !important;
  /* margin: 0 25px 0 0;*/
}
.candPads .detail-tabs .react-tabs__tab {
  /*margin: 0 18px;*/
}

div.accordion-button.tag::after {
  position: absolute;
}
.container.row.h-100 {
  padding-right: 0px;
}

.replayav .chatProf {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  border: 1px solid #dfdfdf;
  overflow: hidden;
}
.replayav .chatProf img {
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  object-fit: cover;
}
img.send_icon {
  width: 40px;
  height: 40px;
  border-radius: 50px;
}

.temp-top-section {
  display: flex;
  justify-content: space-between;
}
.replayav {
  display: flex;
  align-items: self-start;
  padding: 0px 20px;
  margin: 10px 0;
}
.chat-content {
  width: auto;
  border-radius: 15px;
  box-shadow: 0px 1px 5px #cccccc42;
  padding: 10px 15px;
  margin: 0 5px;
  max-width: 55%;
}
.chat-content-bg {
  background: #e9f8ff;
}
.chat-content-bg2 {
  background: #f8f8f8;
}

.chat-content-bg2 p,
.chat-content-bg p {
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 500;
}

.replay.request .replayav {
  display: flex;
  justify-content: end;
}
.chat {
  /* background: #FAFAFA; */
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  float: left;
  width: 100%;
}
img.send_icon {
  position: absolute;
  right: 20px;
  top: 12px;
  /* left: 10px; */
  /* bottom: 50%; */
}
.chathead .form-group {
  position: relative;
}
button.add-submenuz {
  border: 0;
  background: none;
  margin-left: 15px;
}
ul.nav.submenu.tag-grp li span button {
  border: 0;
  background: 0;
  margin-left: 10px;
}

ul.nav.submenu.tag-grp li span {
  background: #9be7ff;
  color: var(--color1);
  padding: 8px 36px 8px 20px;
  border-radius: 30px;
  justify-content: center;
  position: relative;
  display: inline-block;
  margin-right: 4px;
}

ul.nav.submenu.tag-grp {
  display: flex;
}
ul.nav.submenu.tag-grp li span button {
  border: 0;
  background: 0;
  margin-left: 10px;
  position: absolute;
  /*  right: 9px;
    top: 5px;*/
  right: 5px;
  top: 0px;
}
ul.nav.submenu.tag-grp {
  flex-direction: inherit !important;
  flex-wrap: wrap;
}
.bg-check {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.main-bg-check {
  margin: 105px 0px 0px 0px;
}

button.inv-saend {
  /*background: #666666;
    border: 0;
    color: #fff;
    padding: 8px 20px;
    border-radius: 20px;*/
  background: #666666;
  border: 0;
  color: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 300 !important;
}
table.w-100.table-bordered tr td {
  padding: 12px;
  border: 1px solid #f0f0f0 !important;
  color: #302b3a;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
table.w-100.table-bordered tr td:last-child {
  text-align: right;
}
.userlist .hd-can {
  min-height: auto;
  /*padding-top: 20px;
    padding-bottom: 30px;*/
}
.m_3x {
  margin: -1rem !important;
}

.can-lists .d-flex.userlist {
  padding: 0;
}

.candPads {
  padding-left: 13px !important;
}

.d-flex.userlist {
  padding: 0px;
  border-radius: 10px;
  background: #fff;
  margin: 0;
  /* max-height: 62vh;
    height: auto; */

  display: flex;
  flex-direction: column;
}
.d-flex.detail-user {
  border-radius: 10px;
  background: #fff;
  height: auto;
  margin: 0;
  flex-direction: column;
}
/*.blueBorder{  border: 1px solid #3A68D8; !important; }*/

/*.d-flex.detail-user:hover {
    border-radius: 10px;
    border: 1px solid var(--Active-State, #3A68D8;);
    background: var(--White, #FFF);
  
}*/
.container-fluid.row.h-100 {
  padding-right: 0px;
  margin-right: 0px !important;
  --bs-gutter-x: 0px;
}
.action-itms {
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  width: 100%;
  padding: 20px 0px 20px 0px;
  margin-left: 0px;
  border-radius: 10px;
  margin-bottom: 22px;
  background: #fff;
}

.ac-spaceBt {
  margin-bottom: 15px;
}

.form-control::placeholder {
  color: #bcb7b7;
}

input.form-control.border-0 {
  border-radius: 0px;
  background: none;
  margin: 0px;
  color: #949494;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
button.status-btn.active {
  background: var(--color1);
  color: #fff;
  border-color: var(--color1);
}

button.status-btn {
  border: 1px solid #e8e8e8;
  background: #fff;
  margin: 0 0.4%;
  padding: 0.76px 20px;
  border-radius: 10px;
  height: 40px;
  color: #666;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: calc(100% / 5);
  justify-content: center;
  align-items: center;
  gap: 10.093px;
}

.react-tabs__tab-panel .table > :not(caption) > * > * {
  padding: 0.9rem 0.5rem;
}

.d-flex.inv-det button:hover {
  background: var(--color1);
  color: #fff;
}
/* .search {
    width: 13%;
} */

.men-btn.d-flex.align-items-center {
  width: 100%;
  justify-content: center;
}
.tm-buttons {
  flex: 1 1;
  display: flex;
  justify-content: space-between;
  /* width: 100%; */
  margin-left: -5px;
  margin-right: -5px;
}
.team-member {
  /*width: 17%;*/
  width: 15%;
}
#us-scroll {
  height: 100%;
  overflow-y: auto;
  width: 100% !important;
  margin: 0 !important;
}

.candScroll#us-scroll {
  height: 68.5vh;
  /* height: 100%; */
}

/*.iner-sc {
    height: 100%;
    overflow-y: auto;
}*/

.replay {
  margin-top: 17px;
}
.chatarea {
  overflow-y: auto;
  min-height: 80px;
}
.user-itm .ca-details h3 {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #302b3a !important;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
}

.user-itm .ca-details {
  cursor: pointer;
  color: var(--gray-accessible-text, #666);
  font-family: Man "Manrope", sans-serifrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wrapp {
  /* height: calc(100vh - 540px);*/
  overflow: scroll;
  height: auto;
}
select.form-select.status {
  margin-left: 10px;
  font-size: 12px;
}
img.sAdd {
  width: 20px;
}
.hd-attach h3 {
  font-size: 16px;
  margin-bottom: 0px;
  margin: 0px 30px;
}
img.sdots {
  width: 6px;
}
img.files {
  width: 17px;
  margin-right: 10px;
}
img.sample-f {
  background: #cccccc3d;
  padding: 30px;
  margin: 0px;
  border-radius: 10px;
  margin-top: 20px;
}
.folder-itm.d-flex.justify-content-center.align-items-center.file-view {
  padding: 12px;
  margin-bottom: 20px;
}
.folder-itm.d-flex.justify-content-center.align-items-center.file-view h5 {
  font-size: 16px;
}
.hd-attach {
  display: flex;
}

.hd-can.create-form-wrp {
  flex-direction: column;
  align-items: flex-start;
}
.accordion-button:not(.collapsed)::after {
  /* background-image: url(../images/dropdown.svg) !important; */
  opacity: 0.5;
}
.action-itms.full-drp {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
button.select-btn {
  background: none;
  border: 0;
  outline: 0;
}
.hd-can.create-form-wrp h4 {
  margin-bottom: 10px;
  color: var(--avenu-black, #302b3a);

  font-family: "Manrope", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;

  padding: 20px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  margin-top: -20px;
}
img.create-icon {
  max-width: 22px;
  margin-bottom: 10px;
}

.component img.create-icon {
  width: auto;
}
a.create-comp {
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0;
  align-self: stretch;
  border-radius: 15px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
  color: black;

  margin-bottom: 20px;
  padding: 50px 20px;
  /* display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #fff;
    margin: 0 0 15px;
    padding: 20px 10px;
    color: #000;
    border-radius: 0;
    border-bottom: 1px solid var(--light-gray-outline, #DFDFDF);*/
}
.rightCont img.create-icon {
  max-width: 20px;
}
.serchField.space {
  margin: 0;
}

a.create-comp h6 {
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  padding: 0;
}
.action-itms.form-act {
  background: none;
  padding: 0;
  border: 0;
  margin-bottom: 0px;
}
/* a.create-comp.active {
    background: var(--color1);
    color: #fff;
}
a.create-comp.active h6 {
    color: #fff;
}
a.create-comp:hover h6 {
    color: #fff;
}
a.create-comp:hover {
    background: var(--color1);
} */
.col-lg-6 .create-comp:hover {
  background: inherit !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}
.col-lg-6 a.create-comp:hover h6 {
  color: inherit !important;
}
img.eye_icon {
  width: 25px;
  margin-right: 10px;
}
a.btn-primary.preview {
  margin-right: 30px;
  color: var(--avenu-black, #302b3a);
  font-family: "Manrope", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.sub-acc {
  padding: 15px 20px;
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
}
.wrapAlign .sub-acc .txtAlgn {
  padding: 10px 0px;
}
.wrapAlign .sub-acc .txtAlgn .form_titles {
  border: 0;
}

.sub-acc h6 {
  font-size: 15px;
  margin: 0;
  padding: 0;
}

.accordion-item {
  border: 0;
  background: none;
}
.sub-acc ul li a.active {
  color: #000;
  background: #cccccc75;
  border-radius: 40px;
}
.sub-acc ul li a {
  color: #949494;
  display: flex;
  padding: 8px 25px;
}
h6 {
  font-weight: bold;
}

button.Save {
  padding: 5px 40px;
  border-radius: 5px;
  border: 0;
  background: var(--color1);
  color: #fff;
}
.create-grd .save-btn button.Save {
  border-radius: 10px;
  min-height: 40px;
  font-size: 15px;
  font-weight: 500;
}
.need-help.border.rounded.p-3 img {
  margin-right: 10px;
  margin-bottom: 0px;
}

.need-help.border.rounded.p-3 {
  display: flex;
}
div.component {
  padding: 0 !important;
  align-items: center;
}

.editor {
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  height: 250px;
  margin-left: 1px;
  margin-top: 10px;
}
.fn-main ul li a {
  display: flex;
  flex-direction: column;
}
.fn-main ul li {
  width: 50%;
  padding: 10px;
}
.fn-main ul {
  display: flex;
  flex-wrap: wrap;
}
div.component {
  padding: 20px 0px !important;
  align-items: center;
  border: 1px solid #ccc;
  height: 100%;
  width: 100%;
  /* margin: 10px 0px; */
  border-radius: 10px;
}
div.component h6 {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}
.alignBox.fn-main ul li .component h6 {
  text-align: center;
}
.sub-acc.h-100.moves,
.wraper.h-100.moves {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.accordion-button::after {
  opacity: 0.5;
}
span.stars {
  margin: 2px 0px 0px 0px;
  color: var(--Error-State-Color, #f93a2f);
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
span.stars-jobs {
  margin: 2px 0px 0px 0px;
  color: var(--Error-State-Color, #f93a2f);
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

label.form-label {
  display: flex;
  align-items: center;
}
button.btn.btn-primary.Add-pop.mx-3 {
  background: var(--color1);
  color: #fff;
  margin: 0px 0px 5px 15px !important;
}
.ReactModal__Content.ReactModal__Content--after-open {
  border-radius: 5px !important;
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(
    --bs-table-color-state,
    var(--bs-table-color-type, var(--bs-table-color))
  );
  background-color: var(--bs-table-bg);
  border-bottom: none !important;
  box-shadow: inset 0 0 0 9999px
    var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.ReactModal__Overlay.ReactModal__Overlay--after-open {
  background-color: rgb(0 0 0 / 33%) !important;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ReactModal__Content.ReactModal__Content--after-open.hidde-dives {
  z-index: 2000;
  background: white;
}

.ReactModal__Content.ReactModal__Content--after-open.tem-hide-dives {
  z-index: 100;
  background: white;
}

.ReactModal__Content.ReactModal__Content--after-open.delet-temp {
  z-index: 101;
  background: white;
}

.modal-header {
  margin-bottom: 8px;
  border-radius: 15px 15px 0px 0px;
  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;
  background: var(--White, #fff);
}
.ReactModal__Content.ReactModal__Content--after-open {
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.ReactModal__Content.ReactModal__Content--after-open {
  display: flex;
  flex-direction: column;
  box-shadow: inherit !important;
}
button.addnw img {
  width: 22px;
}

.pl-3 {
  padding-left: 1rem;
}

button.addnw {
  border: 0;
  background: none;
}
.can-lists button.addnw {
  margin: 0;
  padding-left: 0;
}
.progress-bar2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
  /*width: 100% !important;*/
}
.progress.custom {
  height: 5px;
  width: 100%;
}
.task-count {
  display: flex;
  align-items: center;
  margin: 0px 10px 0px 0px;
}
ul.status-ind li a {
  padding: 10px 20px;
  display: flex;
  color: #000;
}
ul.status-ind li.tops {
  margin: 20px 0 0;
}
ul.status-ind li a.active.ms-5z {
  background: #f8f8f8;
  border-radius: 62px;
  color: #000;
  font-weight: 500;
  font-size: 17px;
  padding: 5px !important;
  text-align: center;
  width: 100%;
  display: block;
}
ul.status-ind li a {
  padding: 5px 10px;
  display: flex;
  color: #666666;
  font-size: 15px;
  word-break: break-word !important;
}

ul.status-ind.viewList a .review-pre-cand-link {
  cursor: auto;
}

ul.status-ind.viewList a .review-pre-cand-link :hover {
  cursor: default;
  background-color: #0065fd;
}

.conversation-modal {
  width: 100%;
  min-width: 110vh !important;
  min-height: 92vh !important;
  background-color: white;
}

.status-ind.spaceBx {
  padding: 0 10px !important;
}
.ms-5z {
  padding-left: 54px !important;
}
ul.status-ind {
  width: 100%;
}
ul.status-ind li {
  margin-bottom: 10px;
}

.statBox {
  padding: 5px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.sideCont .progress.custom {
  height: 10px;
  width: 100%;
  background-color: #c0d2ff;
}

.dateWrap {
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  border-radius: 10px;
  padding: 10px 20px;
  background-color: white;
}
.dateWrap p.dates {
  font-size: 15px;
  font-weight: 500;
  margin: 5px 0;
}

.dateWrap p.dates span {
  color: var(--colorGrey);
  font-size: 14px;
  display: block;
  font-weight: 400;
}

ul.status-ind.viewList a {
  padding: 5px 8%;
}

.topSpce_view {
  padding-top: 6rem !important;
  background: #fbfbfb;
  min-height: 100vh !important;
}

.fixHeader {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  background-color: #fff;
  min-height: 70px;
}
.userarea.new {
  align-items: center;
  display: flex;
}

.pdfHeight_new {
  height: 80vh;
  overflow-y: auto;
}

.btnSty {
  font-size: 14px;
  padding: 10px 25px !important;
}
sideCont {
  position: relative;
}

.sidebarFixs {
  position: fixed;
  max-width: 100%;
  width: 14%;
  /*z-index: 10;*/
  overflow: scroll;
}

.rightCont .form-floating .form-control {
  line-height: inherit !important;
  /* padding: 1.1rem 0.75rem 0 !important;*/
  height: auto !important;
}
.rightCont .form-floating > .form-control:not(:placeholder-shown) ~ label {
  padding-bottom: 0;
  padding-top: 0.5rem;
}

.rightCont .form-floating.minH .form-control {
  min-height: 61px;
}

.rightCont .contents-sub.fulWid {
  width: 100%;
  padding: 10px 15px 0;
}

.statBox .titles {
  margin: 10px 0 5px;
  padding: 0;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.3px;
}
.statBox .descp {
  margin: 0 0 10px;
  letter-spacing: 1px;
  padding: 0;
  font-weight: 400;
  font-size: 14px;
  color: #666;
}

ul.status-ind li img.create-icon {
  /* width: 20px;
    object-fit: cover;
    height: 20px;*/
  width: 17%;
  object-fit: cover;
  height: 30px;
}
.sideCont ul.status-ind li img.create-icon {
  width: 21px;
  object-fit: cover;
  height: 21px;
  max-width: 21px;
  cursor: auto;
}
.candPrv .logo-sec {
  width: 100%;
  justify-content: center;
  display: flex;
  position: relative;
  float: left;
}
.candPrv .logo-sec img {
  width: auto !important;
  max-height: 36px;
  max-width: 230px;
}
.candPrv .logo-sec {
  width: auto;
  display: inline-flex;
  float: none;
  align-items: center;
}
.candPrv .logoSide.logo-sec {
  position: absolute;
  right: 45px;
  top: 17px;
  z-index: 0;
}
.candPrv {
  border-bottom: 1px solid #dfdfdf;
}
img.logo-inner.mb-0.me-2 {
  width: 140px;
}
.w-100.logo-sec {
  display: flex;
  justify-content: center;
  padding: 10px 20px;
  position: relative;
  min-height: 70px;
}

img.right_icon {
  width: 16px;
  margin: 0 8px 0 0px;
}
li.create-F a {
  color: #000;
  display: flex;
  margin: 10px 0px;
}
img.right_icon.group-Add {
  height: 16px !important;
}
li.create-G {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
li.create-G {
  padding: 6px 10px;
}
.grp-hd img {
  margin: 0;
  width: 23px;
}

.grp-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.form-group.preview_s {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #cccccc9e;
  padding-bottom: 18px;
  margin-top: 40px !important;
  margin-bottom: 20px;
}
.modal-body.file-edit .form-group {
  margin-top: 20px;
}
.color-btn-grp button {
  width: 22px;
  height: 22px;
  margin: 3px;
  border-radius: 100px;
  border: 1px solid;
}
.color-btn-grp button:nth-child(1) {
  background-color: #f93a2f;
}
.color-btn-grp button:nth-child(2) {
  background-color: #ff9534;
}
.color-btn-grp button:nth-child(3) {
  background-color: #ffb900;
}
.color-btn-grp button:nth-child(4) {
  background-color: #13dc27;
}
.color-btn-grp button:nth-child(5) {
  background-color: #61d9ff;
}
.color-btn-grp button:nth-child(6) {
  background-color: #0065fd;
}
.color-btn-grp button:nth-child(7) {
  background-color: #7525f6;
}
.color-btn-grp button:nth-child(8) {
  background-color: #ff09f5;
}
.color-btn-grp.text button:nth-child(1) {
  background-color: #302b3a;
}
.color-btn-grp.text button:nth-child(2) {
  background-color: #fff;
}
span.preview {
  background: #ffb900;
  display: flex;
  align-items: center;
  padding: 0px 17px;
  font-size: 13px;
  border-radius: 30px;
}
button.btn.btn-primary.save-pop.save-update {
  background: #0b5ed7;
  color: #fff;
}
button.btn.btn-primary.cancel {
  background: none;
  color: #666666;
}
button.selected {
  position: relative;
}
button.selected::after {
  position: absolute;
  content: "\\2713";
  color: #fff;
  top: 3px;
  display: flex;
}

.action-itms.full-drp.flex-column.collap-main {
  cursor: pointer;
}

.rightCont .hd-can-review.newPad {
  padding-left: 10px;
  padding-top: 0;
}

button.next-btn {
  color: #fff;
  border: 0;
  width: 100%;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  min-width: 100px;
  min-height: 42px;
  border-radius: 7px !important;
  line-height: inherit !important;
  width: 15%;
}

button.submits-btn {
  color: #fff;
  border: 0;
  width: 100%;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;
  min-width: 100px;
  min-height: 42px;
  border-radius: 7px !important;
  line-height: inherit !important;
  width: 15%;
}

button.confirm-btn {
  color: #fff;
  border: 0;
  width: auto;
  min-width: 100px;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Manrope", sans-serif;

  background: #3a68d8;
  /*margin: 0 15px 0 0;*/
  width: 100%;
  width: 15%;
}

button.yes-btn {
  color: #fff;
  border: 0;
  width: auto;
  justify-content: space-between;
  background: #3a68d8;
  text-align: center;
  min-width: 80px;
  font-size: 15px;
}
button.upload-btn.me-3 {
  border: 1px solid #949494;
  background: #fff;
  padding: 8px 30px;
  border-radius: 5px;
}
.sign-area ul li {
  list-style: disc;
  margin-left: 22px;
}
.document-view {
  padding: 20px;
  border-radius: 10px;
  margin-top: 20px;
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--White, #fff);
}
.head-buttons a {
  color: #000;
}

.head-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.collap-head .task-count .select-btn img,
.collap-Subhead .select-btn img {
  transform: rotate(180deg) !important;
}
.collap-head.collapsed .task-count .select-btn img {
  transform: rotate(0deg) !important;
}
.collap-head.collapsed
  .action-itms.full-drp.w-100.collapsed
  .task-count
  .select-btn
  img,
.collap-Subhead.collapsed .select-btn img {
  transform: rotate(0deg) !important;
}
.collap-head.collapsed .action-itms.full-drp.w-100 .task-count .select-btn img {
  transform: rotate(180deg) !important;
}
.pending {
  border: 1px solid #ed1414;
}

.can-lists,
.d-flex.detail-user {
  border-radius: 10px;
  border: 1px solid var(--light-gray-outline, #dfdfdf);
  background: var(--white, #fff);
  margin: 0;
  min-height: 100%;
  height: 74vh;
}
.can-lists.my-team-lists {
  height: 72.3vh;
}

.container-fluid.row {
  height: calc(100% - 88px);
}
/* body{
    overflow: hidden;
} */

.main-content {
  height: 70vh;
  overflow: auto;
  width: 100%;
  margin-top: 0px;
}
ul.grp-listing.navigations {
  width: 100%;
}
ul.grp-listing.navigations div#accordionExample {
  width: 100%;
}
ul.py-3.listing-lists li a {
  margin-bottom: 12px;
  color: #000 !important;
  display: flex;
}
.action-itms.full-drp.w-100.flex-column.exit {
  display: inline-block;
}
.wraper.h-100.moves > div {
  width: 100%;
}
.wraper.h-100.moves ul {
  width: 100% !important;
}

.detail-tabs .react-tabs__tab {
  bottom: 0;
  border: 0px solid transparent;
  /*margin: 0px 18px 0px 0px;*/
}

.team-member select {
  /* font-size: 14px !important;
    color: #000;
    font-weight: 500;
    text-align: center;
    display: inline-flex;
    align-items: center;
    gap: 11px;*/

  color: var(--Avenu-Black, #302b3a);
  font-family: "Manrope", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

h4 {
  font-size: 20px;
  font-weight: 600;
}
.dropdown ul li {
  display: flex;
  align-items: center;
}
img.rightarrow {
  width: 10px;
  margin-right: 12px;
}

.sidebar_open.main-content.edit.hight-av {
  min-height: 98% !important;
}

.hd-can-review.neSp {
  padding: 0;
}

.hd-can-review.neSp h4 {
  margin: 10px 0;
  padding: 0;
}

.action-itms.fulWid {
  width: 100%;
  padding: 15px;
  margin: 0;
}
.contents-sub.fulWid {
  width: 100%;
  padding: 10px 15px;
  margin: 0;
}
.accordion-header.newOne {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.accordion-header.newOne .accordion-button {
  display: inline-block;
  width: auto !important;
}

.accordion-header.newOne .menu-title {
  margin-left: 0;
}

.hd-can h4.allTxt {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}
.userlist .hd-can h4.allTxt {
  font-weight: 600;
}

.detail-user .iner-sc {
  height: 65vh;
  min-height: 100%;
  overflow-y: auto;
}
/* .chat.iner-sc{  max-height: inherit; height: 33.3vh; } */

.sub-acc p {
  color: var(--gray-accessible-text, #666);
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.drop-filter.customFilt {
  border: 0;
}

.row.g-3.create-grd .col-lg-4 {
  width: 29.333333% !important;
}
.row.g-3.create-grd .col-lg-2 {
  width: 19.666667% !important;
}
button {
  cursor: pointer;
}

.candPads .alignTops {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.signs {
  font-family: "Great Vibes", cursive;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.pdf-doc.viewerPage .pdfHeight_new {
  height: 75vh;
  overflow-y: auto;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}

.sideScroll {
  width: 100%;
  /* overflow-y: scroll;*/
  height: 100vh;
  max-height: 100vh;
}

.candPads .detail-tabs {
  margin-top: 0 !important;
}

.react-tabs__tab-panel .iner-sc .table th {
  padding: 0.2rem 0.9rem 0.5rem 0.9rem;
}

.react-tabs__tab-panel .iner-sc .table {
  margin: 0 !important;
}

.pr-3 {
  padding-right: 1rem;
}

.detail-user .iner-sc.scrlHe-tab {
  margin: 0;
}

.status-div {
  align-items: end;
  padding-bottom: 0px;
  padding-right: 20px;
  padding-top: 10px;
  position: relative;

  display: flex;
}

select.form-select.status {
  font-size: 15px;
  margin-left: 10px;
}

/* #us-scroll::-webkit-scrollbar, .candScroll::-webkit-scrollbar {
    width: 20px !important; 
  }
  
#us-scroll::-webkit-scrollbar-track, .candScroll::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey !important; 
    border-radius: 10px !important; 
  }
   
  #us-scroll::-webkit-scrollbar-thumb, .candScroll::-webkit-scrollbar-thumb {
    background: red !important;  
    border-radius: 10px !important; 
  }
  
  #us-scroll::-webkit-scrollbar-thumb:hover, .candScroll::-webkit-scrollbar-thumb:hover {
    background: #b30000;   } */
/* }  */

@media (min-width: 1920px) and (max-width: 2560px) {
  /* .can-lists {  min-height: 69vh !important; } 
     .d-flex.userlist { max-height: 66vh !important;}
    .d-flex.detail-user { min-height: 69vh !important;}   
     .detail-user .iner-sc {  max-height: 45vh; }

    .move-div {
        padding-top: 10px;
        height: 340px;
        width: 100%;
        overflow-y: scroll;
        margin-top: 20px;
    } */

  .px-1
    .py-1
    a.lign-middle
    .mt-0
    .dev-giri
    .rag-common
    .rewamp_wrap
    .rewamp-head-centerss {
    padding: 10px;
    border: 1px solid #000 !important;
    word-break: auto-phrase;
  }

  .build-choose {
    color: #302b3a;
    font-family: Manrope;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: contents;
  }
}

/* @media screen and (min-width: 1600px) and (max-width: 2000px) { 
    .move-div {
        padding-top: 10px;
        height: 466px !important;
        width: 100%;
        overflow-y: scroll;
        margin-top: 20px;
    }

    .detail-user .iner-sc { max-height: 46vh; }
} */

@media screen and (max-height: 1440) and (max-width: 2560px) {
  .build-choose {
    color: var(--Avenu-Black, #302b3a);
    font-weight: 400;
    line-height: normal;
    display: contents;
  }
}
@media (min-height: 1500px) and (max-height: 1600px) {
  .can-lists,
  .d-flex.detail-user {
    height: 81vh;
  }
  .detail-user .iner-sc {
    height: 70.4vh;
  }
  .candScroll#us-scroll {
    height: 75.2vh;
  }
}
@media (min-height: 1380px) and (max-height: 1499px) {
  .can-lists,
  .d-flex.detail-user {
    height: 80vh;
  }
  .detail-user .iner-sc {
    height: 63.5vh;
    .chathead {
      position: absolute;
      top: 92%;
      left: 16px;
      right: 16px;
    }
  }
  .candScroll#us-scroll {
    height: 73.8vh;
  }
}
@media (min-height: 1300px) and (max-height: 1379px) {
  .can-lists,
  .d-flex.detail-user {
    height: 80vh;
  }
  .detail-user .iner-sc {
    height: 68.3vh;
  }
  .candScroll#us-scroll {
    height: 73.6vh;
  }
}
@media (min-height: 1179px) and (max-height: 1299px) {
  .can-lists,
  .d-flex.detail-user {
    height: 79vh;
  }

  .tempops-border {
    height: 90vh;
  }

  .wraper.scrlHe-tab.scroll.scroll1.temppos-height {
    height: 100vh;
  }

  .detail-user .iner-sc {
    height: 66.4vh;
  }
  .chathead {
    position: absolute;
    top: 92%;
    left: 16px;
    right: 16px;
  }
  input.form-control.mesg-cht {
    /*height: 113px;*/
  }
  .candScroll#us-scroll {
    height: 72vh;
  }
}

@media (min-height: 1091px) and (max-height: 1178px) {
  .can-lists,
  .d-flex.detail-user {
    height: 77vh;
  }
  .detail-user .iner-sc {
    height: 48.2vh;
  }
  .candScroll#us-scroll {
    height: 69.2vh;
  }
}
@media (min-height: 1061px) and (max-height: 1090px) {
  .can-lists,
  .d-flex.detail-user {
    height: 75vh;
  }
  .detail-user .iner-sc {
    height: 60.2vh;
  }
  .candScroll#us-scroll {
    height: 67.2vh;
  }

  .pdfHeight_limit {
    height: 64vh;
  }
}
@media (min-height: 981px) and (max-height: 1060px) {
  .can-lists,
  .d-flex.detail-user {
    height: 74vh;
  }

  .tempops-border {
    height: 82vh;
  }
  .detail-user .iner-sc {
    height: 51.6vh;
  }
  .chathead {
    position: absolute;
    top: 88%;
    left: 16px;
    right: 16px;
  }
}
.candScroll#us-scroll {
  height: 65.5vh;
}

.pdfHeight_limit {
  height: 58vh;
}

@media (min-height: 920px) and (max-height: 980px) {
  .can-lists,
  .d-flex.detail-user {
    height: 80vh;
  }
  .detail-user .iner-sc {
    height: 55.6vh;
  }
  .chathead {
    position: absolute;
    top: 88%;
    left: 16px;
    right: 16px;
  }
  .detail-user .conv-sc {
    height: 62.4vh;
  }
  input.form-control.mesg-cht {
    /*height: 104px;*/
  }
  .candScroll#us-scroll {
    height: 72.3vh;
  }

  .pdfHeight_limit {
    height: 56vh;
  }
}
@media (min-height: 850px) and (max-height: 919px) {
  .can-lists,
  .d-flex.detail-user {
    height: 79vh;
  }

  .tempops-border {
    height: 86vh;
  }
  .detail-user .iner-sc {
    height: 54.5vh;
    .chathead {
      position: absolute;
      top: 89%;
      left: 16px;
      right: 16px;
    }
  }
  .candScroll#us-scroll {
    height: 69.7vh;
  }
  .detail-user .conv-sc {
    height: 51.4vh;
  }
}
@media (min-height: 779px) and (max-height: 849px) {
  .can-lists,
  .d-flex.detail-user {
    height: 76vh;
  }
  .detail-user .iner-sc {
    /*height: 50.5vh;*/
    height: 51.5vh;
  }
  .candScroll#us-scroll {
    height: 68.5vh;
  }
  .chathead {
    position: absolute;
    top: 88%;
    left: 16px;
    right: 16px;
  }
  input.form-control.mesg-cht {
    /* height: 100px;*/
  }
  .detail-user .conv-sc {
    height: 56.4vh;
  }
}
@media (min-height: 731px) and (max-height: 780px) {
  .can-lists,
  .d-flex.detail-user {
    height: 75.5vh;
  }
  .detail-user .iner-sc {
    height: 48.7vh;
  }
  .candScroll#us-scroll {
    height: 63vh;
  }
  .chathead {
    position: absolute;
    top: 87%;
    left: 16px;
    right: 16px;
  }
  .detail-user .conv-sc {
    height: 51.4vh;
  }
}
@media (min-height: 700px) and (max-height: 730px) {
  .can-lists,
  .d-flex.detail-user {
    height: 72vh;
    /*height: 74.5vh*/
  }
  .detail-user .iner-sc {
    /*height: 44.5vh*/
    height: 51.5vh;
  }
  .candScroll#us-scroll {
    height: 60vh;
    /*height: 64.5vh*/
  }
  .detail-user .conv-sc {
    height: 51.4vh;
  }
}
@media (min-height: 600px) and (max-height: 699px) {
  .can-lists,
  .d-flex.detail-user {
    /*height: 68.5vh;*/
    height: 70.5vh;
  }
  .detail-user .iner-sc {
    /* height: 47.5vh;*/
    height: 32.5vh;
  }
  .detail-user .conv-sc {
    height: 40.2vh;
  }
  .candScroll#us-scroll {
    /*height: 58vh;*/
    height: 60vh;
  }

  .footer_collapse.mt-2 {
    padding-top: 0;
  }
}
@media screen and (max-height: 713px) {
  .pdfHeight_limit {
    height: 49vh;
  }
}
@media screen and (max-width: 767px) {
  /*today*/

  ul.status-ind li a {
    padding: 10px 10px 20px 0px;
    display: flex;
    color: #666666;
    font-size: 15px;
    word-break: break-word;
    margin: 0px 0px 0px 0px;
  }

  /*today*/

  .candPrv .logoSide.logo-sec {
    /* position: relative;
        right: inherit;*/
    top: inherit;
    z-index: 0;
    margin: 0 5px;
  }
  .candPrv .logo-sec {
    margin: 0 40px;
  }
  a.create-comp {
    padding: 10px 20px;
  }
  a.create-comp h6 {
    color: #fff;
    margin-bottom: 0px;
  }
  /*today*/
  .action-itms.full-drp {
    /*flex-direction: column;
        align-items: flex-start;*/

    flex-direction: column;
    align-items: center;
    display: flex;

    /*    height: 27vh;
    justify-content: flex-end;*/
  }

  /*.e-pdfviewer:not(.e-pv-mobile-view) .e-pv-viewer-main-container {
       min-width: 100%;
    }*/
  .hd-can-review {
    display: inline;
    align-items: center;
    height: auto;
    padding: 0px 0px 0px 0px;
  }
  .e-toolbar-items.e-tbar-pos {
    display: contents !important;
    /* justify-content: space-between !important; */
    /* align-items: center; */
    padding: 0px 0px;
  }

  .action-itms {
    border: 1px solid var(--light-gray-outline, #dfdfdf);
    width: 100%;
    padding: 20px 0px 20px 0px;
    margin-left: 0px;
    border-radius: 10px;
    margin-bottom: 22px;
    background: #fff;
    height: auto;
  }
  /*today*/
  .row.p-5 {
    padding: 10px !important;
  }
  .action-itms.full-drp.flex-column .d-flex {
    flex-direction: inherit;
  }
  .task-count {
    flex-direction: column-reverse;
  }
  .task-count {
    flex-direction: row;
    margin-bottom: 12px;
    justify-content: space-between;
  }
  .hd-can.create-form-wrp h4 {
    margin-bottom: 10px;
    font-size: 17px;
  }
  .container-fluid {
    padding: 5px;
  }

  /*today*/
  .action-itms {
    /*padding: 16px;*/
    padding: 15px 0px 0px 0px;
    /*today*/
  }
  .contents-sub.row.w-100 {
    width: inherit !important;
  }
  .progress.custom {
    width: 100%;
    margin-bottom: 0px;
  }
  button.next-btn {
    width: 100%;
  }
  .contents-sub .row.w-100 {
    width: inherit !important;
  }
  .form-floating.mb-3.d-flex.justify-content-end {
    width: 100%;

    float: left;

    position: relative;
    /* margin: 30px 22px 0px 0px;*/
  }

  .uploads.d-flex.align-items-center.my-5 img {
    margin-left: 0px !important;
  }
  button.upload-btn.me-3 {
    margin-right: 0px !important;
  }
  .container-fluid.row {
    width: inherit !important;
  }
  body {
    overflow: scroll;
  }
  .can-lists {
    width: 100% !important;
  }
  .can-lists + div {
    width: 100% !important;
  }
  .can-lists {
    height: -moz-fit-content;
    height: fit-content;
    margin-bottom: 20px;
  }
  /* .sidebar_opn {
        padding: 10px;
    } */
  .inner-hd.d-flex.align-items-center.justify-content-between {
    flex-direction: column;
  }
  .he-65,
  .he-60 {
    max-height: 100%;
    /* overflow-y: auto; */
  }
  .main-content {
    height: inherit;
    overflow: auto;
    width: 100%;
    min-height: inherit;
    margin-top: 0px;
  }
  .inner-hd-links a {
    margin-bottom: 10px;
    padding: 10px;
    background: #e9e9e9;
    width: 100%;
  }
  .inner-hd-links {
    /* padding: 10px; */
    display: flex;
    flex-direction: column;
    /* background: #000; */
    margin-top: 15px;
  }

  .team-member {
    width: 93% !important;
    border: 1px solid #ccc;
    margin-bottom: 6px;
    border-radius: 5px;
    margin-left: 12px;
  }
  .footer_collapse {
    position: fixed;
    bottom: 0;
    background: #000;
    display: flex;
    align-items: center;
  }
  .footer_collapse.mt-2 p {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/inbox.css"],"names":[],"mappings":"AACA,cAAc;;AAEd;EACE,mBAAmB;EACnB,mBAAmB;EACnB;wBACsB;EACtB,WAAW;EACX,WAAW;EACX,gBAAgB;;EAEhB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;;;GAOG;;AAEH;EACE;;;;;;;uBAOqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;;AAEA;;;;;;;;;EASE;;AAEF;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA,KAAK;AACL;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;AACtC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,kBAAkB;;EAElB,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;;EAElB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,QAAQ;EACR,YAAY;AACd;;AAEA,KAAK;;AAEL;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;;;GAGG;AACH;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;EAC7C,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;iCAC+B;EAC/B,mBAAmB;EACnB,4BAA4B;;EAE5B,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE;;;;;;;yBAOuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6CAA6C;EAC7C,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,WAAW;EACX,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;GAEG;AACH;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,2CAA2C;EAC3C,yBAAyB;;EAEzB,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB;cACY;EACZ,UAAU;EACV,QAAQ;AACV;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;;;yBAIuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB;0BACwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT;mBACiB;;EAEjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,sBAAsB;AACxB;AACA,yDAAyD;;AAEzD;;;;;EAKE;AACF;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,oDAAoD;EACpD,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;;GAEG;;AAEH;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE;;AAEF;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,8DAA8D;EAC9D,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kCAAkC;;EAElC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;;EAEb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,SAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,YAAY;;EAEZ,mBAAmB;EACnB,kBAAkB;EAClB;;;;;;;;;iEAS+D;AACjE;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;AACA;;;;;;;;;;;;GAYG;AACH;EACE,8BAA8B;EAC9B,8DAA8D;AAChE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB;;;GAGC;EACD,oCAAoC;EACpC,8BAA8B;EAC9B;gFAC8E;AAChF;AACA;EACE,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sEAAsE;EACtE,8BAA8B;AAChC;AACA;EACE,mCAA8B;EAA9B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,6CAA6C;EAC7C,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,OAAO;EACP,MAAM;EACN,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE;;kBAEgB;EAChB,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;;EAElC,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;;;;;;EAME,kCAAkC;AACpC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;GAEG;;AAEH;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;;;;;;eAMa;;EAEb,kCAAkC;EAClC,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA,2DAA2D;;AAE3D;EACE,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;;EAElB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;8BAe8B;AAC9B,OAAO;;AAEP;EACE;;;;;;;;;;;OAWK;;EAEL;;;;;;;;IAQE,aAAa;IACb,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE;IACE,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE;;IAEE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,YAAY;EACd;EACA;IACE,cAAc;IACd;MACE,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,WAAW;IACb;EACF;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;AACF;AACA;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;AACF;AACA;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd;MACE,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,WAAW;IACb;EACF;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;EACb;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,QAAQ;;EAER;IACE,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,QAAQ;;EAER;IACE;wBACoB;IACpB,YAAY;IACZ,UAAU;IACV,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA,QAAQ;EACR;IACE;iCAC6B;;IAE7B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;;IAEb;+BAC2B;EAC7B;;EAEA;;MAEI;EACJ;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,4BAA4B;IAC5B,+CAA+C;IAC/C,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,oDAAoD;IACpD,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;EACA,QAAQ;EACR;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,YAAY;EACd;;EAEA,QAAQ;EACR;IACE,iBAAiB;IACjB,yBAAyB;IACzB,QAAQ;EACV;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;;IAEX,WAAW;;IAEX,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;;OAEK;EACL;IACE,sBAAsB;EACxB;EACA;;IAEE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap\");\n/* Sign Font */\n\n.sidebar_open {\n  /* padding: 22px; */\n  /* float: inherit;*/\n  /* border: 1px solid #DFDFDF;\n     background: #fff; */\n  width: 100%;\n  margin: 0px;\n  border-radius: 0;\n\n  min-height: 100%;\n  height: auto;\n  float: left;\n}\n.he-65,\n.he-60 {\n  max-height: 67vh;\n  overflow-y: auto;\n}\n/* .sidebar_opn {\n    padding: 22px;\n    height: calc(100% - 30px);\n    float: inherit;\n    width: inherit;\n    border-radius: 10px;\n    overflow: scroll;\n} */\n\n.avatar {\n  /*height: 40px;\n    width: 40px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 50%;\n    padding: 5px;\n    min-width: 40px;\n    line-height: 30px;*/\n  width: 45px;\n  height: 45px;\n  border: 1px solid #dfdfdf;\n  border-radius: 100%;\n  text-align: center;\n  line-height: 45px;\n  color: #302b3a;\n  font-weight: 800;\n  display: inline-block;\n}\n.textSty {\n  width: 100%;\n  justify-content: center;\n  color: #000;\n}\n.avatar p {\n  color: #fff;\n  font-weight: 700;\n  margin: -3px;\n  width: 50px;\n}\n.alignTops .dropbtn {\n  min-height: 54px;\n}\n.dropbtn.btnArw:after {\n  top: 25px;\n}\n\n/*.alignTops .candidate .avatar{\n    height: 54px;\n    width: 54px;\n    min-width: 54px;\n    line-height: 43px;\n}\n.alignTops .candidate .avatar p {\n    font-size: 18px;\n    font-weight: 700 !important;\n}*/\n\n.candidate img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50px;\n}\n.close-image {\n  /* margin: -38px 0px 0px 80px; */\n  width: 15px;\n  position: absolute;\n  top: 7px;\n  right: 10px;\n}\n/*pv*/\nhtml,\nbody,\n#root {\n  overflow-x: hidden;\n}\n\n.textarea .notes-box :hover,\ntextarea .notes-box :focus {\n  border: 1px solid #dcdcdc !important;\n}\n.download-img {\n  margin: 3px 20px 0px 0px;\n}\n.under-line {\n  width: 100%;\n  border: 1px solid #dcdcdc;\n  margin: -11px 0px 0px 0px;\n}\n.dot {\n  height: 25px;\n  width: 25px;\n  background-color: none;\n  border-radius: 50%;\n  display: inline-block;\n  color: #ffb900;\n  font-size: 15px;\n  border: 1px solid #ffb900;\n}\n.number-dot {\n  padding: 0px 0px 0px 8px;\n}\n\n.call-text {\n  color: #666;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.no-msg {\n  text-align: center;\n  margin: 60px 0px 0px 0px;\n  font-size: 15px;\n  color: black !important;\n  font-weight: 500;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  line-height: normal;\n  /* text-transform: capitalize; */\n}\n.check-add_icon {\n  width: 40%;\n  padding: 0px 6px 5px 0px;\n}\n.add-pop {\n  display: flex;\n  position: relative;\n\n  height: 40px;\n  float: right;\n}\n.add-pop-selects {\n  display: flex;\n  position: relative;\n\n  height: 40px;\n  width: 100%;\n  /*       max-width: 173px; */\n  top: 4px;\n  float: right;\n}\n\n/*pv*/\n\niframe.frame-view {\n  width: 100%;\n  height: calc(100vh - 188px);\n  overflow: scroll;\n  max-height: 70vh;\n}\nbutton.update-btn {\n  color: #fff;\n  border: 0;\n  width: auto;\n  justify-content: space-between;\n  border-radius: 10.093px;\n  background: #3a68d8;\n  margin: -8px 0px 0px 25px;\n  text-align: center;\n  min-width: 80px;\n  font-size: 15px;\n}\n.candidate {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.hd-can {\n  display: flex;\n  align-items: center;\n  /* min-height: 70px;*/\n  min-height: 45px !important;\n}\n/* .hd-can h4 {\n    margin-bottom: -7px;\n    font-size: 14px;\n} */\n.hd-can-review {\n  /* display: flex; */\n  align-items: center;\n  height: auto;\n  padding: 15px 15px 0px 35px;\n}\n.form-floating.mb-5 {\n  margin: 15px 0px 0px 0px;\n}\n\n.form-floating.mb-5 {\n  margin: 15px 0px 0px 0px;\n}\n\n.hd-can-review h4 {\n  color: var(--Avenu-Black, #302b3a) !important;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.hd-can-review.create-form-wrp.newPad h4 {\n  margin: 0;\n}\n\n.hd-can-review.create-form-wrp h4.mainTits {\n  font-family: \"Manrope\", sans-serif !important;\n  font-weight: 600;\n  font-size: 16px;\n  margin: 0;\n}\n\n.contents-sub.padd-main .action-itms.full-drp:last-child {\n  margin: 0 !important;\n}\n\nbutton.btn_resetFrom {\n  /* min-height: 44px;\n    min-width: 120px !important;*/\n  border-radius: 10px;\n  letter-spacing: 0 !important;\n\n  color: #fff;\n  border: 0;\n  width: auto;\n  min-width: 100px;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  margin-left: 10px;\n}\n.hd-can-review .create-form-wrp {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.hd-can-review .create-form-wrp {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.hd-can-review .create-form-wrp h4 {\n  margin-bottom: 10px;\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  display: flex;\n  padding: 20px 40px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 25px;\n  margin-top: -20px;\n}\n.candidate .ca-details {\n  margin-left: 10px;\n}\n\n.ca-details {\n  /*margin-left: 40px;*/\n}\n\n.ca-details h3 {\n  margin-bottom: 0px;\n  font-size: 17px;\n}\n.d-flex.userlist ul {\n  margin: 0px;\n}\nspan.count-ca {\n  /*background: #3A68D8; \n    width: 27px !important;\n    height: 27px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0px 0px 0px 5px;\n    border-radius: 55px;*/\n  background: #3a68d8;\n  line-height: 31px;\n  min-width: 30px;\n  height: 30px;\n  border-radius: 60px;\n  display: inline-block;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: center;\n  padding: 0 7px;\n  margin-left: 8px;\n}\nspan.count-ca .count-number {\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n}\n\n.docBrad li.breadcrumb-item a {\n  color: #666666;\n  font-size: 13px;\n  font-weight: 500;\n}\n.docBrad li.breadcrumb-item.active {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n}\n.topAlg {\n  margin: 0 3px 0 0;\n}\n\n.topAlg hr {\n  padding: 0;\n  margin: 10px 0 0;\n  opacity: 0.05;\n}\n\nol.breadcrumb {\n  align-items: center;\n}\n.progress-bar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  color: #000;\n  font-size: 12px;\n  font-weight: 700;\n}\ntable.table td.tabLast_ch {\n  width: 100px;\n  text-align: end;\n}\n.tabLast_ch .f-btns.doc {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n.tabLast_ch .f-btns.doc button {\n  padding: 0 5px;\n  margin: 0 0 0 5px;\n}\n.tabLast_ch .f-btns.doc img {\n  margin: 0 !important;\n}\n\n.detail-tabs .table tbody.table-text-body td {\n  text-wrap: balance;\n  min-width: 180px;\n}\n.detail-tabs\n  .table\n  tbody.table-text-body\n  .firstTab.arrow-btwn.myteam-algment\n  td {\n  text-wrap: balance;\n  max-width: 150px;\n}\n\n.detail-tabs\n  .table\n  tbody.table-text-body\n  .firstTab.arrow-btwn.myteam-algmenttd\n  .text-end\n  td {\n  text-wrap: balance;\n  min-width: 170px;\n}\ntd.text-end-onbo {\n  min-width: 210px !important;\n}\ntd.text-end.my-temss {\n  min-width: 150px !important;\n}\ntd.text-end.my-tems-staus {\n  min-width: 195px !important;\n}\n.ca-details span {\n  color: #666;\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 25ch;\n}\n.ca-details span.styDiv {\n  color: var(--color1);\n}\n.ca-details .styDiv {\n  /* color: var(--gray-accessible-text, #666);*/\n  color: #3a68d8;\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  /*text-decoration-line: underline !important;*/\n  display: block;\n}\n\n.ca-details {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.ca-details h3 {\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: capitalize;\n  max-width: 16ch !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.can-lists li.user-itm {\n  position: relative;\n  margin: 10px 0px 0;\n  padding: 0px 15px 0px 14px;\n}\n.can-lists .user-itm a.candidate {\n  padding: 0 0 13px;\n  margin: 0 0px 0px;\n  border-radius: 0;\n  background-color: #fff;\n  border-bottom: 1px solid #f0f0f0;\n}\n.can-lists .user-itm a.candidate::before {\n  border-left: 3px solid transparent;\n  content: \" \";\n  position: absolute;\n  left: 0px;\n  top: 0;\n  z-index: 1;\n  height: 76%;\n  display: inline-block;\n  border-radius: 9px;\n}\n.can-lists .user-itm a.candidate.active::before {\n  border-left: 3px solid var(--color1);\n}\n.can-lists .user-itm a.candidate.active .ca-details h3,\n.can-lists .user-itm a.candidate.active .ca-details span {\n  color: var(--color1) !important;\n}\na.candidate {\n  padding: 12px 0px;\n  border-radius: 50px;\n}\n/* a.candidate.active {\n    background: #F8F8F8;\n} */\n.ca-details span img {\n  width: 16px;\n  height: 16px;\n}\n\nimg.download-pdf {\n  width: 15px;\n}\nspan.dwn {\n  font-weight: 600;\n}\n\nul.actn-btns li {\n  margin-right: 1px;\n}\nul.actn-btns.contDts li {\n  display: flex;\n  align-items: center;\n}\nul.actn-btns.contDts li.emailTab {\n  margin-left: 20px;\n}\n\nul.actn-btns {\n  display: flex;\n  align-items: center;\n}\nul.actn-btns li a img {\n  width: 15px;\n}\nul.actn-btns li:last-child {\n  margin-right: 0px;\n}\n.llbw {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 35px;\n}\n.detail-user .llbw {\n  margin-bottom: 10px;\n}\n\n.progress-bar.detail {\n  margin-left: 40px;\n}\n.main-de {\n  margin-bottom: 20px;\n}\n.d-flex.inv-det button {\n  margin: 5px;\n  border: 1px solid #dfdfdf;\n  color: var(--color1);\n  background: #fff;\n  border-radius: 5px;\n  padding: 5px 20px;\n  width: 85%;\n  height: 35px;\n}\n.d-flex.inv-det button.active {\n  background: var(--color1);\n  color: #fff;\n  width: 85%;\n  height: 35px;\n}\n.d-flex.inv-det {\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\nbutton.dwn {\n  border: 0;\n  background: none;\n}\n.react-tabs__tab--selected {\n  background: none !important;\n  border-color: var(--color1);\n  color: black;\n  border-radius: 0px;\n  /* border: 3px solid transparent; */\n  border-bottom: 3px solid #316af7 !important;\n  color: #3a68d8 !important;\n\n  font-family: \"Manrope\", sans-serif;\n  font-style: normal;\n  font-weight: 600 !important;\n  line-height: normal;\n}\n.react-tabs__tab-list {\n  border: 0 !important;\n}\n.react-tabs__tab:focus:after {\n  background: none !important;\n}\n.tables.docTable table td:first-child {\n  padding-left: 0 !important;\n}\n\n.tables.docTable table td:last-child {\n  padding-right: 0 !important;\n}\n\n.tables.docTable table td {\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.react-tabs__tab {\n  /*color: var(--colorGrey);*/\n  color: #302b3a;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500 !important;\n  line-height: normal;\n  padding: 5px 0px 10px !important;\n  border-radius: 0 !important;\n  /* margin: 0 25px 0 0;*/\n}\n.candPads .detail-tabs .react-tabs__tab {\n  /*margin: 0 18px;*/\n}\n\ndiv.accordion-button.tag::after {\n  position: absolute;\n}\n.container.row.h-100 {\n  padding-right: 0px;\n}\n\n.replayav .chatProf {\n  width: 40px;\n  height: 40px;\n  border-radius: 50px;\n  border: 1px solid #dfdfdf;\n  overflow: hidden;\n}\n.replayav .chatProf img {\n  min-width: 40px;\n  max-width: 40px;\n  min-height: 40px;\n  object-fit: cover;\n}\nimg.send_icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50px;\n}\n\n.temp-top-section {\n  display: flex;\n  justify-content: space-between;\n}\n.replayav {\n  display: flex;\n  align-items: self-start;\n  padding: 0px 20px;\n  margin: 10px 0;\n}\n.chat-content {\n  width: auto;\n  border-radius: 15px;\n  box-shadow: 0px 1px 5px #cccccc42;\n  padding: 10px 15px;\n  margin: 0 5px;\n  max-width: 55%;\n}\n.chat-content-bg {\n  background: #e9f8ff;\n}\n.chat-content-bg2 {\n  background: #f8f8f8;\n}\n\n.chat-content-bg2 p,\n.chat-content-bg p {\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.replay.request .replayav {\n  display: flex;\n  justify-content: end;\n}\n.chat {\n  /* background: #FAFAFA; */\n  border-radius: 5px;\n  border: 1px solid #e0e0e0;\n  float: left;\n  width: 100%;\n}\nimg.send_icon {\n  position: absolute;\n  right: 20px;\n  top: 12px;\n  /* left: 10px; */\n  /* bottom: 50%; */\n}\n.chathead .form-group {\n  position: relative;\n}\nbutton.add-submenuz {\n  border: 0;\n  background: none;\n  margin-left: 15px;\n}\nul.nav.submenu.tag-grp li span button {\n  border: 0;\n  background: 0;\n  margin-left: 10px;\n}\n\nul.nav.submenu.tag-grp li span {\n  background: #9be7ff;\n  color: var(--color1);\n  padding: 8px 36px 8px 20px;\n  border-radius: 30px;\n  justify-content: center;\n  position: relative;\n  display: inline-block;\n  margin-right: 4px;\n}\n\nul.nav.submenu.tag-grp {\n  display: flex;\n}\nul.nav.submenu.tag-grp li span button {\n  border: 0;\n  background: 0;\n  margin-left: 10px;\n  position: absolute;\n  /*  right: 9px;\n    top: 5px;*/\n  right: 5px;\n  top: 0px;\n}\nul.nav.submenu.tag-grp {\n  flex-direction: inherit !important;\n  flex-wrap: wrap;\n}\n.bg-check {\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n}\n\n.main-bg-check {\n  margin: 105px 0px 0px 0px;\n}\n\nbutton.inv-saend {\n  /*background: #666666;\n    border: 0;\n    color: #fff;\n    padding: 8px 20px;\n    border-radius: 20px;*/\n  background: #666666;\n  border: 0;\n  color: #fff;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 300 !important;\n}\ntable.w-100.table-bordered tr td {\n  padding: 12px;\n  border: 1px solid #f0f0f0 !important;\n  color: #302b3a;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\ntable.w-100.table-bordered tr td:last-child {\n  text-align: right;\n}\n.userlist .hd-can {\n  min-height: auto;\n  /*padding-top: 20px;\n    padding-bottom: 30px;*/\n}\n.m_3x {\n  margin: -1rem !important;\n}\n\n.can-lists .d-flex.userlist {\n  padding: 0;\n}\n\n.candPads {\n  padding-left: 13px !important;\n}\n\n.d-flex.userlist {\n  padding: 0px;\n  border-radius: 10px;\n  background: #fff;\n  margin: 0;\n  /* max-height: 62vh;\n    height: auto; */\n\n  display: flex;\n  flex-direction: column;\n}\n.d-flex.detail-user {\n  border-radius: 10px;\n  background: #fff;\n  height: auto;\n  margin: 0;\n  flex-direction: column;\n}\n/*.blueBorder{  border: 1px solid #3A68D8; !important; }*/\n\n/*.d-flex.detail-user:hover {\n    border-radius: 10px;\n    border: 1px solid var(--Active-State, #3A68D8;);\n    background: var(--White, #FFF);\n  \n}*/\n.container-fluid.row.h-100 {\n  padding-right: 0px;\n  margin-right: 0px !important;\n  --bs-gutter-x: 0px;\n}\n.action-itms {\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  width: 100%;\n  padding: 20px 0px 20px 0px;\n  margin-left: 0px;\n  border-radius: 10px;\n  margin-bottom: 22px;\n  background: #fff;\n}\n\n.ac-spaceBt {\n  margin-bottom: 15px;\n}\n\n.form-control::placeholder {\n  color: #bcb7b7;\n}\n\ninput.form-control.border-0 {\n  border-radius: 0px;\n  background: none;\n  margin: 0px;\n  color: #949494;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\nbutton.status-btn.active {\n  background: var(--color1);\n  color: #fff;\n  border-color: var(--color1);\n}\n\nbutton.status-btn {\n  border: 1px solid #e8e8e8;\n  background: #fff;\n  margin: 0 0.4%;\n  padding: 0.76px 20px;\n  border-radius: 10px;\n  height: 40px;\n  color: #666;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  width: calc(100% / 5);\n  justify-content: center;\n  align-items: center;\n  gap: 10.093px;\n}\n\n.react-tabs__tab-panel .table > :not(caption) > * > * {\n  padding: 0.9rem 0.5rem;\n}\n\n.d-flex.inv-det button:hover {\n  background: var(--color1);\n  color: #fff;\n}\n/* .search {\n    width: 13%;\n} */\n\n.men-btn.d-flex.align-items-center {\n  width: 100%;\n  justify-content: center;\n}\n.tm-buttons {\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  /* width: 100%; */\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.team-member {\n  /*width: 17%;*/\n  width: 15%;\n}\n#us-scroll {\n  height: 100%;\n  overflow-y: auto;\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n.candScroll#us-scroll {\n  height: 68.5vh;\n  /* height: 100%; */\n}\n\n/*.iner-sc {\n    height: 100%;\n    overflow-y: auto;\n}*/\n\n.replay {\n  margin-top: 17px;\n}\n.chatarea {\n  overflow-y: auto;\n  min-height: 80px;\n}\n.user-itm .ca-details h3 {\n  width: 75%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #302b3a !important;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: capitalize;\n}\n\n.user-itm .ca-details {\n  cursor: pointer;\n  color: var(--gray-accessible-text, #666);\n  font-family: Man \"Manrope\", sans-serifrope;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wrapp {\n  /* height: calc(100vh - 540px);*/\n  overflow: scroll;\n  height: auto;\n}\nselect.form-select.status {\n  margin-left: 10px;\n  font-size: 12px;\n}\nimg.sAdd {\n  width: 20px;\n}\n.hd-attach h3 {\n  font-size: 16px;\n  margin-bottom: 0px;\n  margin: 0px 30px;\n}\nimg.sdots {\n  width: 6px;\n}\nimg.files {\n  width: 17px;\n  margin-right: 10px;\n}\nimg.sample-f {\n  background: #cccccc3d;\n  padding: 30px;\n  margin: 0px;\n  border-radius: 10px;\n  margin-top: 20px;\n}\n.folder-itm.d-flex.justify-content-center.align-items-center.file-view {\n  padding: 12px;\n  margin-bottom: 20px;\n}\n.folder-itm.d-flex.justify-content-center.align-items-center.file-view h5 {\n  font-size: 16px;\n}\n.hd-attach {\n  display: flex;\n}\n\n.hd-can.create-form-wrp {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.accordion-button:not(.collapsed)::after {\n  /* background-image: url(../images/dropdown.svg) !important; */\n  opacity: 0.5;\n}\n.action-itms.full-drp {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\nbutton.select-btn {\n  background: none;\n  border: 0;\n  outline: 0;\n}\n.hd-can.create-form-wrp h4 {\n  margin-bottom: 10px;\n  color: var(--avenu-black, #302b3a);\n\n  font-family: \"Manrope\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  display: flex;\n\n  padding: 20px 40px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 25px;\n  margin-top: -20px;\n}\nimg.create-icon {\n  max-width: 22px;\n  margin-bottom: 10px;\n}\n\n.component img.create-icon {\n  width: auto;\n}\na.create-comp {\n  display: flex;\n  padding: 10px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex: 1 0 0;\n  align-self: stretch;\n  border-radius: 15px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n  color: black;\n\n  margin-bottom: 20px;\n  padding: 50px 20px;\n  /* display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background: #fff;\n    margin: 0 0 15px;\n    padding: 20px 10px;\n    color: #000;\n    border-radius: 0;\n    border-bottom: 1px solid var(--light-gray-outline, #DFDFDF);*/\n}\n.rightCont img.create-icon {\n  max-width: 20px;\n}\n.serchField.space {\n  margin: 0;\n}\n\na.create-comp h6 {\n  font-weight: 500;\n  font-size: 16px;\n  margin: 0;\n  padding: 0;\n}\n.action-itms.form-act {\n  background: none;\n  padding: 0;\n  border: 0;\n  margin-bottom: 0px;\n}\n/* a.create-comp.active {\n    background: var(--color1);\n    color: #fff;\n}\na.create-comp.active h6 {\n    color: #fff;\n}\na.create-comp:hover h6 {\n    color: #fff;\n}\na.create-comp:hover {\n    background: var(--color1);\n} */\n.col-lg-6 .create-comp:hover {\n  background: inherit !important;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n.col-lg-6 a.create-comp:hover h6 {\n  color: inherit !important;\n}\nimg.eye_icon {\n  width: 25px;\n  margin-right: 10px;\n}\na.btn-primary.preview {\n  margin-right: 30px;\n  color: var(--avenu-black, #302b3a);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.sub-acc {\n  padding: 15px 20px;\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n}\n.wrapAlign .sub-acc .txtAlgn {\n  padding: 10px 0px;\n}\n.wrapAlign .sub-acc .txtAlgn .form_titles {\n  border: 0;\n}\n\n.sub-acc h6 {\n  font-size: 15px;\n  margin: 0;\n  padding: 0;\n}\n\n.accordion-item {\n  border: 0;\n  background: none;\n}\n.sub-acc ul li a.active {\n  color: #000;\n  background: #cccccc75;\n  border-radius: 40px;\n}\n.sub-acc ul li a {\n  color: #949494;\n  display: flex;\n  padding: 8px 25px;\n}\nh6 {\n  font-weight: bold;\n}\n\nbutton.Save {\n  padding: 5px 40px;\n  border-radius: 5px;\n  border: 0;\n  background: var(--color1);\n  color: #fff;\n}\n.create-grd .save-btn button.Save {\n  border-radius: 10px;\n  min-height: 40px;\n  font-size: 15px;\n  font-weight: 500;\n}\n.need-help.border.rounded.p-3 img {\n  margin-right: 10px;\n  margin-bottom: 0px;\n}\n\n.need-help.border.rounded.p-3 {\n  display: flex;\n}\ndiv.component {\n  padding: 0 !important;\n  align-items: center;\n}\n\n.editor {\n  background-color: white;\n  padding-left: 20px;\n  padding-right: 20px;\n  height: 250px;\n  margin-left: 1px;\n  margin-top: 10px;\n}\n.fn-main ul li a {\n  display: flex;\n  flex-direction: column;\n}\n.fn-main ul li {\n  width: 50%;\n  padding: 10px;\n}\n.fn-main ul {\n  display: flex;\n  flex-wrap: wrap;\n}\ndiv.component {\n  padding: 20px 0px !important;\n  align-items: center;\n  border: 1px solid #ccc;\n  height: 100%;\n  width: 100%;\n  /* margin: 10px 0px; */\n  border-radius: 10px;\n}\ndiv.component h6 {\n  font-size: 14px;\n  color: #000;\n  font-weight: 600;\n}\n.alignBox.fn-main ul li .component h6 {\n  text-align: center;\n}\n.sub-acc.h-100.moves,\n.wraper.h-100.moves {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.accordion-button::after {\n  opacity: 0.5;\n}\nspan.stars {\n  margin: 2px 0px 0px 0px;\n  color: var(--Error-State-Color, #f93a2f);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\nspan.stars-jobs {\n  margin: 2px 0px 0px 0px;\n  color: var(--Error-State-Color, #f93a2f);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\nlabel.form-label {\n  display: flex;\n  align-items: center;\n}\nbutton.btn.btn-primary.Add-pop.mx-3 {\n  background: var(--color1);\n  color: #fff;\n  margin: 0px 0px 5px 15px !important;\n}\n.ReactModal__Content.ReactModal__Content--after-open {\n  border-radius: 5px !important;\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(\n    --bs-table-color-state,\n    var(--bs-table-color-type, var(--bs-table-color))\n  );\n  background-color: var(--bs-table-bg);\n  border-bottom: none !important;\n  box-shadow: inset 0 0 0 9999px\n    var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.ReactModal__Overlay.ReactModal__Overlay--after-open {\n  background-color: rgb(0 0 0 / 33%) !important;\n  z-index: 100;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ReactModal__Content.ReactModal__Content--after-open.hidde-dives {\n  z-index: 2000;\n  background: white;\n}\n\n.ReactModal__Content.ReactModal__Content--after-open.tem-hide-dives {\n  z-index: 100;\n  background: white;\n}\n\n.ReactModal__Content.ReactModal__Content--after-open.delet-temp {\n  z-index: 101;\n  background: white;\n}\n\n.modal-header {\n  margin-bottom: 8px;\n  border-radius: 15px 15px 0px 0px;\n  border-bottom: 1px solid var(--light-gray-outline, #dfdfdf) !important;\n  background: var(--White, #fff);\n}\n.ReactModal__Content.ReactModal__Content--after-open {\n  height: fit-content !important;\n}\n.ReactModal__Content.ReactModal__Content--after-open {\n  display: flex;\n  flex-direction: column;\n  box-shadow: inherit !important;\n}\nbutton.addnw img {\n  width: 22px;\n}\n\n.pl-3 {\n  padding-left: 1rem;\n}\n\nbutton.addnw {\n  border: 0;\n  background: none;\n}\n.can-lists button.addnw {\n  margin: 0;\n  padding-left: 0;\n}\n.progress-bar2 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n  /*width: 100% !important;*/\n}\n.progress.custom {\n  height: 5px;\n  width: 100%;\n}\n.task-count {\n  display: flex;\n  align-items: center;\n  margin: 0px 10px 0px 0px;\n}\nul.status-ind li a {\n  padding: 10px 20px;\n  display: flex;\n  color: #000;\n}\nul.status-ind li.tops {\n  margin: 20px 0 0;\n}\nul.status-ind li a.active.ms-5z {\n  background: #f8f8f8;\n  border-radius: 62px;\n  color: #000;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 5px !important;\n  text-align: center;\n  width: 100%;\n  display: block;\n}\nul.status-ind li a {\n  padding: 5px 10px;\n  display: flex;\n  color: #666666;\n  font-size: 15px;\n  word-break: break-word !important;\n}\n\nul.status-ind.viewList a .review-pre-cand-link {\n  cursor: auto;\n}\n\nul.status-ind.viewList a .review-pre-cand-link :hover {\n  cursor: default;\n  background-color: #0065fd;\n}\n\n.conversation-modal {\n  width: 100%;\n  min-width: 110vh !important;\n  min-height: 92vh !important;\n  background-color: white;\n}\n\n.status-ind.spaceBx {\n  padding: 0 10px !important;\n}\n.ms-5z {\n  padding-left: 54px !important;\n}\nul.status-ind {\n  width: 100%;\n}\nul.status-ind li {\n  margin-bottom: 10px;\n}\n\n.statBox {\n  padding: 5px 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.sideCont .progress.custom {\n  height: 10px;\n  width: 100%;\n  background-color: #c0d2ff;\n}\n\n.dateWrap {\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  border-radius: 10px;\n  padding: 10px 20px;\n  background-color: white;\n}\n.dateWrap p.dates {\n  font-size: 15px;\n  font-weight: 500;\n  margin: 5px 0;\n}\n\n.dateWrap p.dates span {\n  color: var(--colorGrey);\n  font-size: 14px;\n  display: block;\n  font-weight: 400;\n}\n\nul.status-ind.viewList a {\n  padding: 5px 8%;\n}\n\n.topSpce_view {\n  padding-top: 6rem !important;\n  background: #fbfbfb;\n  min-height: 100vh !important;\n}\n\n.fixHeader {\n  width: 100%;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  background-color: #fff;\n  min-height: 70px;\n}\n.userarea.new {\n  align-items: center;\n  display: flex;\n}\n\n.pdfHeight_new {\n  height: 80vh;\n  overflow-y: auto;\n}\n\n.btnSty {\n  font-size: 14px;\n  padding: 10px 25px !important;\n}\nsideCont {\n  position: relative;\n}\n\n.sidebarFixs {\n  position: fixed;\n  max-width: 100%;\n  width: 14%;\n  /*z-index: 10;*/\n  overflow: scroll;\n}\n\n.rightCont .form-floating .form-control {\n  line-height: inherit !important;\n  /* padding: 1.1rem 0.75rem 0 !important;*/\n  height: auto !important;\n}\n.rightCont .form-floating > .form-control:not(:placeholder-shown) ~ label {\n  padding-bottom: 0;\n  padding-top: 0.5rem;\n}\n\n.rightCont .form-floating.minH .form-control {\n  min-height: 61px;\n}\n\n.rightCont .contents-sub.fulWid {\n  width: 100%;\n  padding: 10px 15px 0;\n}\n\n.statBox .titles {\n  margin: 10px 0 5px;\n  padding: 0;\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: 0.3px;\n}\n.statBox .descp {\n  margin: 0 0 10px;\n  letter-spacing: 1px;\n  padding: 0;\n  font-weight: 400;\n  font-size: 14px;\n  color: #666;\n}\n\nul.status-ind li img.create-icon {\n  /* width: 20px;\n    object-fit: cover;\n    height: 20px;*/\n  width: 17%;\n  object-fit: cover;\n  height: 30px;\n}\n.sideCont ul.status-ind li img.create-icon {\n  width: 21px;\n  object-fit: cover;\n  height: 21px;\n  max-width: 21px;\n  cursor: auto;\n}\n.candPrv .logo-sec {\n  width: 100%;\n  justify-content: center;\n  display: flex;\n  position: relative;\n  float: left;\n}\n.candPrv .logo-sec img {\n  width: auto !important;\n  max-height: 36px;\n  max-width: 230px;\n}\n.candPrv .logo-sec {\n  width: auto;\n  display: inline-flex;\n  float: none;\n  align-items: center;\n}\n.candPrv .logoSide.logo-sec {\n  position: absolute;\n  right: 45px;\n  top: 17px;\n  z-index: 0;\n}\n.candPrv {\n  border-bottom: 1px solid #dfdfdf;\n}\nimg.logo-inner.mb-0.me-2 {\n  width: 140px;\n}\n.w-100.logo-sec {\n  display: flex;\n  justify-content: center;\n  padding: 10px 20px;\n  position: relative;\n  min-height: 70px;\n}\n\nimg.right_icon {\n  width: 16px;\n  margin: 0 8px 0 0px;\n}\nli.create-F a {\n  color: #000;\n  display: flex;\n  margin: 10px 0px;\n}\nimg.right_icon.group-Add {\n  height: 16px !important;\n}\nli.create-G {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nli.create-G {\n  padding: 6px 10px;\n}\n.grp-hd img {\n  margin: 0;\n  width: 23px;\n}\n\n.grp-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.form-group.preview_s {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #cccccc9e;\n  padding-bottom: 18px;\n  margin-top: 40px !important;\n  margin-bottom: 20px;\n}\n.modal-body.file-edit .form-group {\n  margin-top: 20px;\n}\n.color-btn-grp button {\n  width: 22px;\n  height: 22px;\n  margin: 3px;\n  border-radius: 100px;\n  border: 1px solid;\n}\n.color-btn-grp button:nth-child(1) {\n  background-color: #f93a2f;\n}\n.color-btn-grp button:nth-child(2) {\n  background-color: #ff9534;\n}\n.color-btn-grp button:nth-child(3) {\n  background-color: #ffb900;\n}\n.color-btn-grp button:nth-child(4) {\n  background-color: #13dc27;\n}\n.color-btn-grp button:nth-child(5) {\n  background-color: #61d9ff;\n}\n.color-btn-grp button:nth-child(6) {\n  background-color: #0065fd;\n}\n.color-btn-grp button:nth-child(7) {\n  background-color: #7525f6;\n}\n.color-btn-grp button:nth-child(8) {\n  background-color: #ff09f5;\n}\n.color-btn-grp.text button:nth-child(1) {\n  background-color: #302b3a;\n}\n.color-btn-grp.text button:nth-child(2) {\n  background-color: #fff;\n}\nspan.preview {\n  background: #ffb900;\n  display: flex;\n  align-items: center;\n  padding: 0px 17px;\n  font-size: 13px;\n  border-radius: 30px;\n}\nbutton.btn.btn-primary.save-pop.save-update {\n  background: #0b5ed7;\n  color: #fff;\n}\nbutton.btn.btn-primary.cancel {\n  background: none;\n  color: #666666;\n}\nbutton.selected {\n  position: relative;\n}\nbutton.selected::after {\n  position: absolute;\n  content: \"\\2713\";\n  color: #fff;\n  top: 3px;\n  display: flex;\n}\n\n.action-itms.full-drp.flex-column.collap-main {\n  cursor: pointer;\n}\n\n.rightCont .hd-can-review.newPad {\n  padding-left: 10px;\n  padding-top: 0;\n}\n\nbutton.next-btn {\n  color: #fff;\n  border: 0;\n  width: 100%;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  min-width: 100px;\n  min-height: 42px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  width: 15%;\n}\n\nbutton.submits-btn {\n  color: #fff;\n  border: 0;\n  width: 100%;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n  min-width: 100px;\n  min-height: 42px;\n  border-radius: 7px !important;\n  line-height: inherit !important;\n  width: 15%;\n}\n\nbutton.confirm-btn {\n  color: #fff;\n  border: 0;\n  width: auto;\n  min-width: 100px;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  font-family: \"Manrope\", sans-serif;\n\n  background: #3a68d8;\n  /*margin: 0 15px 0 0;*/\n  width: 100%;\n  width: 15%;\n}\n\nbutton.yes-btn {\n  color: #fff;\n  border: 0;\n  width: auto;\n  justify-content: space-between;\n  background: #3a68d8;\n  text-align: center;\n  min-width: 80px;\n  font-size: 15px;\n}\nbutton.upload-btn.me-3 {\n  border: 1px solid #949494;\n  background: #fff;\n  padding: 8px 30px;\n  border-radius: 5px;\n}\n.sign-area ul li {\n  list-style: disc;\n  margin-left: 22px;\n}\n.document-view {\n  padding: 20px;\n  border-radius: 10px;\n  margin-top: 20px;\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--White, #fff);\n}\n.head-buttons a {\n  color: #000;\n}\n\n.head-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.collap-head .task-count .select-btn img,\n.collap-Subhead .select-btn img {\n  transform: rotate(180deg) !important;\n}\n.collap-head.collapsed .task-count .select-btn img {\n  transform: rotate(0deg) !important;\n}\n.collap-head.collapsed\n  .action-itms.full-drp.w-100.collapsed\n  .task-count\n  .select-btn\n  img,\n.collap-Subhead.collapsed .select-btn img {\n  transform: rotate(0deg) !important;\n}\n.collap-head.collapsed .action-itms.full-drp.w-100 .task-count .select-btn img {\n  transform: rotate(180deg) !important;\n}\n.pending {\n  border: 1px solid #ed1414;\n}\n\n.can-lists,\n.d-flex.detail-user {\n  border-radius: 10px;\n  border: 1px solid var(--light-gray-outline, #dfdfdf);\n  background: var(--white, #fff);\n  margin: 0;\n  min-height: 100%;\n  height: 74vh;\n}\n.can-lists.my-team-lists {\n  height: 72.3vh;\n}\n\n.container-fluid.row {\n  height: calc(100% - 88px);\n}\n/* body{\n    overflow: hidden;\n} */\n\n.main-content {\n  height: 70vh;\n  overflow: auto;\n  width: 100%;\n  margin-top: 0px;\n}\nul.grp-listing.navigations {\n  width: 100%;\n}\nul.grp-listing.navigations div#accordionExample {\n  width: 100%;\n}\nul.py-3.listing-lists li a {\n  margin-bottom: 12px;\n  color: #000 !important;\n  display: flex;\n}\n.action-itms.full-drp.w-100.flex-column.exit {\n  display: inline-block;\n}\n.wraper.h-100.moves > div {\n  width: 100%;\n}\n.wraper.h-100.moves ul {\n  width: 100% !important;\n}\n\n.detail-tabs .react-tabs__tab {\n  bottom: 0;\n  border: 0px solid transparent;\n  /*margin: 0px 18px 0px 0px;*/\n}\n\n.team-member select {\n  /* font-size: 14px !important;\n    color: #000;\n    font-weight: 500;\n    text-align: center;\n    display: inline-flex;\n    align-items: center;\n    gap: 11px;*/\n\n  color: var(--Avenu-Black, #302b3a);\n  font-family: \"Manrope\", sans-serif !important;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\nh4 {\n  font-size: 20px;\n  font-weight: 600;\n}\n.dropdown ul li {\n  display: flex;\n  align-items: center;\n}\nimg.rightarrow {\n  width: 10px;\n  margin-right: 12px;\n}\n\n.sidebar_open.main-content.edit.hight-av {\n  min-height: 98% !important;\n}\n\n.hd-can-review.neSp {\n  padding: 0;\n}\n\n.hd-can-review.neSp h4 {\n  margin: 10px 0;\n  padding: 0;\n}\n\n.action-itms.fulWid {\n  width: 100%;\n  padding: 15px;\n  margin: 0;\n}\n.contents-sub.fulWid {\n  width: 100%;\n  padding: 10px 15px;\n  margin: 0;\n}\n.accordion-header.newOne {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.accordion-header.newOne .accordion-button {\n  display: inline-block;\n  width: auto !important;\n}\n\n.accordion-header.newOne .menu-title {\n  margin-left: 0;\n}\n\n.hd-can h4.allTxt {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n}\n.userlist .hd-can h4.allTxt {\n  font-weight: 600;\n}\n\n.detail-user .iner-sc {\n  height: 65vh;\n  min-height: 100%;\n  overflow-y: auto;\n}\n/* .chat.iner-sc{  max-height: inherit; height: 33.3vh; } */\n\n.sub-acc p {\n  color: var(--gray-accessible-text, #666);\n  font-family: \"Manrope\", sans-serif;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.drop-filter.customFilt {\n  border: 0;\n}\n\n.row.g-3.create-grd .col-lg-4 {\n  width: 29.333333% !important;\n}\n.row.g-3.create-grd .col-lg-2 {\n  width: 19.666667% !important;\n}\nbutton {\n  cursor: pointer;\n}\n\n.candPads .alignTops {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.signs {\n  font-family: \"Great Vibes\", cursive;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.pdf-doc.viewerPage .pdfHeight_new {\n  height: 75vh;\n  overflow-y: auto;\n  border-left: 1px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n}\n\n.sideScroll {\n  width: 100%;\n  /* overflow-y: scroll;*/\n  height: 100vh;\n  max-height: 100vh;\n}\n\n.candPads .detail-tabs {\n  margin-top: 0 !important;\n}\n\n.react-tabs__tab-panel .iner-sc .table th {\n  padding: 0.2rem 0.9rem 0.5rem 0.9rem;\n}\n\n.react-tabs__tab-panel .iner-sc .table {\n  margin: 0 !important;\n}\n\n.pr-3 {\n  padding-right: 1rem;\n}\n\n.detail-user .iner-sc.scrlHe-tab {\n  margin: 0;\n}\n\n.status-div {\n  align-items: end;\n  padding-bottom: 0px;\n  padding-right: 20px;\n  padding-top: 10px;\n  position: relative;\n\n  display: flex;\n}\n\nselect.form-select.status {\n  font-size: 15px;\n  margin-left: 10px;\n}\n\n/* #us-scroll::-webkit-scrollbar, .candScroll::-webkit-scrollbar {\n    width: 20px !important; \n  }\n  \n#us-scroll::-webkit-scrollbar-track, .candScroll::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey !important; \n    border-radius: 10px !important; \n  }\n   \n  #us-scroll::-webkit-scrollbar-thumb, .candScroll::-webkit-scrollbar-thumb {\n    background: red !important;  \n    border-radius: 10px !important; \n  }\n  \n  #us-scroll::-webkit-scrollbar-thumb:hover, .candScroll::-webkit-scrollbar-thumb:hover {\n    background: #b30000;   } */\n/* }  */\n\n@media (min-width: 1920px) and (max-width: 2560px) {\n  /* .can-lists {  min-height: 69vh !important; } \n     .d-flex.userlist { max-height: 66vh !important;}\n    .d-flex.detail-user { min-height: 69vh !important;}   \n     .detail-user .iner-sc {  max-height: 45vh; }\n\n    .move-div {\n        padding-top: 10px;\n        height: 340px;\n        width: 100%;\n        overflow-y: scroll;\n        margin-top: 20px;\n    } */\n\n  .px-1\n    .py-1\n    a.lign-middle\n    .mt-0\n    .dev-giri\n    .rag-common\n    .rewamp_wrap\n    .rewamp-head-centerss {\n    padding: 10px;\n    border: 1px solid #000 !important;\n    word-break: auto-phrase;\n  }\n\n  .build-choose {\n    color: #302b3a;\n    font-family: Manrope;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    display: contents;\n  }\n}\n\n/* @media screen and (min-width: 1600px) and (max-width: 2000px) { \n    .move-div {\n        padding-top: 10px;\n        height: 466px !important;\n        width: 100%;\n        overflow-y: scroll;\n        margin-top: 20px;\n    }\n\n    .detail-user .iner-sc { max-height: 46vh; }\n} */\n\n@media screen and (max-height: 1440) and (max-width: 2560px) {\n  .build-choose {\n    color: var(--Avenu-Black, #302b3a);\n    font-weight: 400;\n    line-height: normal;\n    display: contents;\n  }\n}\n@media (min-height: 1500px) and (max-height: 1600px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 81vh;\n  }\n  .detail-user .iner-sc {\n    height: 70.4vh;\n  }\n  .candScroll#us-scroll {\n    height: 75.2vh;\n  }\n}\n@media (min-height: 1380px) and (max-height: 1499px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 80vh;\n  }\n  .detail-user .iner-sc {\n    height: 63.5vh;\n    .chathead {\n      position: absolute;\n      top: 92%;\n      left: 16px;\n      right: 16px;\n    }\n  }\n  .candScroll#us-scroll {\n    height: 73.8vh;\n  }\n}\n@media (min-height: 1300px) and (max-height: 1379px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 80vh;\n  }\n  .detail-user .iner-sc {\n    height: 68.3vh;\n  }\n  .candScroll#us-scroll {\n    height: 73.6vh;\n  }\n}\n@media (min-height: 1179px) and (max-height: 1299px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 79vh;\n  }\n\n  .tempops-border {\n    height: 90vh;\n  }\n\n  .wraper.scrlHe-tab.scroll.scroll1.temppos-height {\n    height: 100vh;\n  }\n\n  .detail-user .iner-sc {\n    height: 66.4vh;\n  }\n  .chathead {\n    position: absolute;\n    top: 92%;\n    left: 16px;\n    right: 16px;\n  }\n  input.form-control.mesg-cht {\n    /*height: 113px;*/\n  }\n  .candScroll#us-scroll {\n    height: 72vh;\n  }\n}\n\n@media (min-height: 1091px) and (max-height: 1178px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 77vh;\n  }\n  .detail-user .iner-sc {\n    height: 48.2vh;\n  }\n  .candScroll#us-scroll {\n    height: 69.2vh;\n  }\n}\n@media (min-height: 1061px) and (max-height: 1090px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 75vh;\n  }\n  .detail-user .iner-sc {\n    height: 60.2vh;\n  }\n  .candScroll#us-scroll {\n    height: 67.2vh;\n  }\n\n  .pdfHeight_limit {\n    height: 64vh;\n  }\n}\n@media (min-height: 981px) and (max-height: 1060px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 74vh;\n  }\n\n  .tempops-border {\n    height: 82vh;\n  }\n  .detail-user .iner-sc {\n    height: 51.6vh;\n  }\n  .chathead {\n    position: absolute;\n    top: 88%;\n    left: 16px;\n    right: 16px;\n  }\n}\n.candScroll#us-scroll {\n  height: 65.5vh;\n}\n\n.pdfHeight_limit {\n  height: 58vh;\n}\n\n@media (min-height: 920px) and (max-height: 980px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 80vh;\n  }\n  .detail-user .iner-sc {\n    height: 55.6vh;\n  }\n  .chathead {\n    position: absolute;\n    top: 88%;\n    left: 16px;\n    right: 16px;\n  }\n  .detail-user .conv-sc {\n    height: 62.4vh;\n  }\n  input.form-control.mesg-cht {\n    /*height: 104px;*/\n  }\n  .candScroll#us-scroll {\n    height: 72.3vh;\n  }\n\n  .pdfHeight_limit {\n    height: 56vh;\n  }\n}\n@media (min-height: 850px) and (max-height: 919px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 79vh;\n  }\n\n  .tempops-border {\n    height: 86vh;\n  }\n  .detail-user .iner-sc {\n    height: 54.5vh;\n    .chathead {\n      position: absolute;\n      top: 89%;\n      left: 16px;\n      right: 16px;\n    }\n  }\n  .candScroll#us-scroll {\n    height: 69.7vh;\n  }\n  .detail-user .conv-sc {\n    height: 51.4vh;\n  }\n}\n@media (min-height: 779px) and (max-height: 849px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 76vh;\n  }\n  .detail-user .iner-sc {\n    /*height: 50.5vh;*/\n    height: 51.5vh;\n  }\n  .candScroll#us-scroll {\n    height: 68.5vh;\n  }\n  .chathead {\n    position: absolute;\n    top: 88%;\n    left: 16px;\n    right: 16px;\n  }\n  input.form-control.mesg-cht {\n    /* height: 100px;*/\n  }\n  .detail-user .conv-sc {\n    height: 56.4vh;\n  }\n}\n@media (min-height: 731px) and (max-height: 780px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 75.5vh;\n  }\n  .detail-user .iner-sc {\n    height: 48.7vh;\n  }\n  .candScroll#us-scroll {\n    height: 63vh;\n  }\n  .chathead {\n    position: absolute;\n    top: 87%;\n    left: 16px;\n    right: 16px;\n  }\n  .detail-user .conv-sc {\n    height: 51.4vh;\n  }\n}\n@media (min-height: 700px) and (max-height: 730px) {\n  .can-lists,\n  .d-flex.detail-user {\n    height: 72vh;\n    /*height: 74.5vh*/\n  }\n  .detail-user .iner-sc {\n    /*height: 44.5vh*/\n    height: 51.5vh;\n  }\n  .candScroll#us-scroll {\n    height: 60vh;\n    /*height: 64.5vh*/\n  }\n  .detail-user .conv-sc {\n    height: 51.4vh;\n  }\n}\n@media (min-height: 600px) and (max-height: 699px) {\n  .can-lists,\n  .d-flex.detail-user {\n    /*height: 68.5vh;*/\n    height: 70.5vh;\n  }\n  .detail-user .iner-sc {\n    /* height: 47.5vh;*/\n    height: 32.5vh;\n  }\n  .detail-user .conv-sc {\n    height: 40.2vh;\n  }\n  .candScroll#us-scroll {\n    /*height: 58vh;*/\n    height: 60vh;\n  }\n\n  .footer_collapse.mt-2 {\n    padding-top: 0;\n  }\n}\n@media screen and (max-height: 713px) {\n  .pdfHeight_limit {\n    height: 49vh;\n  }\n}\n@media screen and (max-width: 767px) {\n  /*today*/\n\n  ul.status-ind li a {\n    padding: 10px 10px 20px 0px;\n    display: flex;\n    color: #666666;\n    font-size: 15px;\n    word-break: break-word;\n    margin: 0px 0px 0px 0px;\n  }\n\n  /*today*/\n\n  .candPrv .logoSide.logo-sec {\n    /* position: relative;\n        right: inherit;*/\n    top: inherit;\n    z-index: 0;\n    margin: 0 5px;\n  }\n  .candPrv .logo-sec {\n    margin: 0 40px;\n  }\n  a.create-comp {\n    padding: 10px 20px;\n  }\n  a.create-comp h6 {\n    color: #fff;\n    margin-bottom: 0px;\n  }\n  /*today*/\n  .action-itms.full-drp {\n    /*flex-direction: column;\n        align-items: flex-start;*/\n\n    flex-direction: column;\n    align-items: center;\n    display: flex;\n\n    /*    height: 27vh;\n    justify-content: flex-end;*/\n  }\n\n  /*.e-pdfviewer:not(.e-pv-mobile-view) .e-pv-viewer-main-container {\n       min-width: 100%;\n    }*/\n  .hd-can-review {\n    display: inline;\n    align-items: center;\n    height: auto;\n    padding: 0px 0px 0px 0px;\n  }\n  .e-toolbar-items.e-tbar-pos {\n    display: contents !important;\n    /* justify-content: space-between !important; */\n    /* align-items: center; */\n    padding: 0px 0px;\n  }\n\n  .action-itms {\n    border: 1px solid var(--light-gray-outline, #dfdfdf);\n    width: 100%;\n    padding: 20px 0px 20px 0px;\n    margin-left: 0px;\n    border-radius: 10px;\n    margin-bottom: 22px;\n    background: #fff;\n    height: auto;\n  }\n  /*today*/\n  .row.p-5 {\n    padding: 10px !important;\n  }\n  .action-itms.full-drp.flex-column .d-flex {\n    flex-direction: inherit;\n  }\n  .task-count {\n    flex-direction: column-reverse;\n  }\n  .task-count {\n    flex-direction: row;\n    margin-bottom: 12px;\n    justify-content: space-between;\n  }\n  .hd-can.create-form-wrp h4 {\n    margin-bottom: 10px;\n    font-size: 17px;\n  }\n  .container-fluid {\n    padding: 5px;\n  }\n\n  /*today*/\n  .action-itms {\n    /*padding: 16px;*/\n    padding: 15px 0px 0px 0px;\n    /*today*/\n  }\n  .contents-sub.row.w-100 {\n    width: inherit !important;\n  }\n  .progress.custom {\n    width: 100%;\n    margin-bottom: 0px;\n  }\n  button.next-btn {\n    width: 100%;\n  }\n  .contents-sub .row.w-100 {\n    width: inherit !important;\n  }\n  .form-floating.mb-3.d-flex.justify-content-end {\n    width: 100%;\n\n    float: left;\n\n    position: relative;\n    /* margin: 30px 22px 0px 0px;*/\n  }\n\n  .uploads.d-flex.align-items-center.my-5 img {\n    margin-left: 0px !important;\n  }\n  button.upload-btn.me-3 {\n    margin-right: 0px !important;\n  }\n  .container-fluid.row {\n    width: inherit !important;\n  }\n  body {\n    overflow: scroll;\n  }\n  .can-lists {\n    width: 100% !important;\n  }\n  .can-lists + div {\n    width: 100% !important;\n  }\n  .can-lists {\n    height: fit-content;\n    margin-bottom: 20px;\n  }\n  /* .sidebar_opn {\n        padding: 10px;\n    } */\n  .inner-hd.d-flex.align-items-center.justify-content-between {\n    flex-direction: column;\n  }\n  .he-65,\n  .he-60 {\n    max-height: 100%;\n    /* overflow-y: auto; */\n  }\n  .main-content {\n    height: inherit;\n    overflow: auto;\n    width: 100%;\n    min-height: inherit;\n    margin-top: 0px;\n  }\n  .inner-hd-links a {\n    margin-bottom: 10px;\n    padding: 10px;\n    background: #e9e9e9;\n    width: 100%;\n  }\n  .inner-hd-links {\n    /* padding: 10px; */\n    display: flex;\n    flex-direction: column;\n    /* background: #000; */\n    margin-top: 15px;\n  }\n\n  .team-member {\n    width: 93% !important;\n    border: 1px solid #ccc;\n    margin-bottom: 6px;\n    border-radius: 5px;\n    margin-left: 12px;\n  }\n  .footer_collapse {\n    position: fixed;\n    bottom: 0;\n    background: #000;\n    display: flex;\n    align-items: center;\n  }\n  .footer_collapse.mt-2 p {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
